/*!--------------------------------------------------------------------------
// <copyright file="GSS.PortalContainer.js" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var GSS;
(function (GSS) {
    /**
     * @description Provides functionality for working with portal container.
     */
    var pc;
    (function (pc) {
        /**
         * @description A class represents a component.
         */
        var Component = /** @class */ (function () {
            function Component() {
            }
            return Component;
        }());
        pc.Component = Component;
        /**
         * @description A class that represents a component event.
         */
        var ComponentEvent = /** @class */ (function () {
            function ComponentEvent() {
            }
            return ComponentEvent;
        }());
        pc.ComponentEvent = ComponentEvent;
        /** A module containing common content functionality. */
        var Content;
        (function (Content) {
            /** Stores LKM content by space and content key. */
            var _cachedContent = {};
            /** Represents a content request. */
            var ContentRequest = /** @class */ (function () {
                function ContentRequest() {
                    /** An array of ContentRequestData. */
                    this.data = [];
                }
                return ContentRequest;
            }());
            Content.ContentRequest = ContentRequest;
            /**
             * Gets LKM content
             * @param contentRequest The data for the content request.
             */
            function getContentAsync(contentRequest) {
                return new Promise(function (resolve, reject) {
                    var _results = {};
                    var _allKeysFound = true;
                    // Check for the content in the local cache
                    for (var i = 0; i < contentRequest.data.length; i++) {
                        var _data_1 = contentRequest.data[i];
                        var _space = _data_1.groupName;
                        for (var j = 0; j < _data_1.contentKeys.length; j++) {
                            var _key = _data_1.contentKeys[j];
                            var _value = tryGetFromResourceLookup(_cachedContent, _space, _key);
                            if (_value) {
                                addToResourceLookup(_results, _space, _key, _value);
                            }
                            else {
                                _allKeysFound = false;
                                break;
                            }
                        }
                        if (!_allKeysFound) {
                            break;
                        }
                    }
                    // If all the content was found in the local cache, return the results
                    if (_allKeysFound) {
                        resolve(_results);
                        return;
                    }
                    // Otherwise, call the api
                    var _data = {
                        language: contentRequest.language || PortalContainer.getSiteLanguage(),
                        contentGroups: contentRequest.data
                    };
                    var _url = '../_content/getcontent';
                    var _request = GSS.pc.Request.postAsync(null, _url, _data, "application/json");
                    _request.then(function (data) {
                        var _data = JSON.parse(data);
                        if (_data && _data.ContentGroups) {
                            for (var i = 0; i < _data.ContentGroups.length; i++) {
                                var _contentGroup = _data.ContentGroups[i];
                                for (var j = 0; j < _contentGroup.Content.length; j++) {
                                    var _content = _contentGroup.Content[j];
                                    addToResourceLookup(_results, _contentGroup.SpaceName, _content.Key, _content.Value);
                                    addToResourceLookup(_cachedContent, _contentGroup.SpaceName, _content.Key, _content.Value);
                                }
                            }
                            resolve(_results);
                        }
                        else {
                            reject("No data");
                        }
                    });
                });
            }
            Content.getContentAsync = getContentAsync;
            /**
             * Gets the resource value from the specified ResourceLookup. If the space or key don't exist, a null is returned.
             * @param lookup The ResourceLookup to pull from.
             * @param space The resource space.
             * @param key The resource key.
             */
            function tryGetFromResourceLookup(lookup, space, key) {
                if (!lookup[space]) {
                    return null;
                }
                if (!lookup[space][key]) {
                    return null;
                }
                return lookup[space][key];
            }
            /**
             * Sets the value in the specified ResourceLookup by space and key.
             * @param lookup The ResourceLookup to set data for.
             * @param space The resource space.
             * @param key The resource key.
             * @param value The resource value to set.
             */
            function addToResourceLookup(lookup, space, key, value) {
                if (!lookup[space]) {
                    lookup[space] = {};
                }
                lookup[space][key] = value;
            }
        })(Content = pc.Content || (pc.Content = {}));
        /**
         * @description Changes the client and returns to the dashboard.
         * @param {string} newClientId The new client id.
         */
        function changeClient(el) {
            PortalContainer.progressShow();
            var _prefix = '';
            var _newClientId = $(el).closest('[data-gss-clientid]').attr('data-gss-clientid');
            if ($(location).attr('pathname').indexOf('/gss') != -1) {
                // Pull the first five characters, i.e. "/gssd", "/gssq", etc
                _prefix = $(location).attr('pathname').substr(0, 5);
            }
            if (typeof GSS.analytics !== 'undefined') {
                GSS.analytics.changeClient(el);
            }
            // Remove session data tied to old client
            var _clientUserDataKey = '__client_user_data';
            var _clientUserDataJWTKey = '__client_user_data_jwt';
            var _userDataKey = '__user_data';
            var _session = new GSS.common.session(true);
            _session.remove(_clientUserDataKey);
            _session.remove(_userDataKey);
            _session.remove(_clientUserDataJWTKey);
            $(location).attr('href', 'https://' + $(location).attr('hostname') + _prefix + '/_home/index?gssClientId=' + _newClientId);
            return false;
        }
        pc.changeClient = changeClient;
        /**
         * @description Provides functionality for working with bell notification data.
         */
        var BellNotification;
        (function (BellNotification) {
            /**
             * @description Opens a SignalR websocket connection to continuously receive the new notification count.
             */
            function observeNotificationCount() {
                GSS.PortalContainer.SignalR.Notifications.startObservingNotifications(function (count) {
                    if (count) {
                        $('#notificationCount').gssRemoveClass('hidden').text(count.toString());
                    }
                });
            }
            BellNotification.observeNotificationCount = observeNotificationCount;
            function bellNotificationClick() {
                var notificationURL = $('#bellNotificationClick').attr("data-gss-notificationURL");
                return (notificationURL == "#" ? false : true);
            }
            BellNotification.bellNotificationClick = bellNotificationClick;
        })(BellNotification = pc.BellNotification || (pc.BellNotification = {}));
        /**
         * @description Provides functionality for working with cart data.
         */
        var Cart;
        (function (Cart) {
            /**
             * @description Defines the values.
             * @type {object}
             */
            Cart.values = {
                cart: 'divCart',
                cartNavElement: 'cartNav',
                notificationElement: 'cartCount'
            };
            /**
             * @description Gets the cart items.
             * @returns {boolean} Return true if the function succeeds.
             */
            function getCart() {
                var _data = {};
                var dashboardWidgetId = GSS.common.getAttributeValue(GSS.widget.attributeNames.dashboardWidgetId, null);
                _data = GSS.PortalContainer.setRequiredData(dashboardWidgetId, _data);
                var _url = '../_Portal/Cart';
                var _request = GSS.PortalContainer.Request.getByEvent(this, _url, _data, GSS.common.returnType.Json, GSS.common.modalProgress.Disable, false, 5000);
                _request.then(function (data) {
                    var _$notifications = GSS.widget.getElementByGssName(Cart.values.notificationElement);
                    var _$cartNav = GSS.widget.getElementByGssName(Cart.values.cartNavElement);
                    if (_$notifications) {
                        if (data.CartCount && data.CartCount > 0) {
                            // If data came back and the cart has items...
                            // Update the notification text value...
                            _$notifications.text(data.CartCount);
                            // Unhide the notification icon if it is still hidden...
                            _$notifications.removeClass('hidden');
                            // If there are items then the 'href' on the anchor needs to have #showcart added
                            var _hrefBefore = _$cartNav.attr('href');
                            var _cartAnchor = '#showcart';
                            if (_hrefBefore.indexOf(_cartAnchor) === -1) {
                                var _newHref = _hrefBefore + _cartAnchor;
                                _$cartNav.attr('href', _newHref);
                            }
                        }
                        else {
                            // If there are no items in the cart, hide the notification icon and remove the #/cart from the anchor
                            _$notifications.addClass('hidden');
                            var _hrefBefore = _$cartNav.attr('href');
                            var _newHref = _hrefBefore.replace('#/cart', '');
                            _$cartNav.attr('href', _newHref);
                        }
                    }
                });
                return true;
            }
            Cart.getCart = getCart;
        })(Cart = pc.Cart || (pc.Cart = {}));
        /**
         * @description Provides functionality for working with component data.
         */
        var Components;
        (function (Components) {
            /**
             * @property Stores the components based on code name.
             */
            var _componentsByCodeName = {};
            /**
             * @property Stores the components based on component id.
             */
            var _componentsById = {};
            /**
             * @description Defines the different types of components.
             * @type {object}
             */
            Components.ComponentType = {
                Application: 'app',
                Page: 'page',
                Section: 'section'
            };
            /**
             * @description Defines the different types of events.
             * @type {object}
             */
            Components.EventType = {
                custom: 'custom',
                mount: 'mount',
                unMount: 'unmount',
            };
            /**
             * @description Gets all component data.</
             * @returns {object} All of the components.
             */
            function dump() {
                // <summary>Gets all component data.</summary>
                return _componentsByCodeName;
            }
            Components.dump = dump;
            /**
             * @description Publishes the mount event for the specified component id.
             * @param {number} componentId The id of the component to mount.
             */
            function mount(componentId) {
                var _component = getById(componentId);
                if (_component.mountEvent && _component.mountEvent != null && _component.mountEvent.eventName != null) {
                    pc.EventBus.publish(_component.mountEvent.eventName, _component.mountEvent.settings);
                }
            }
            Components.mount = mount;
            /**
             * @description Gets the configuration for the specified component based on the id.
             * @param {number} componentId The component id of the component to get.
             * @returns{Component} A component.
             */
            function getById(componentId) {
                var _result = null;
                if (_componentsById && _componentsById != null) {
                    _result = _componentsById[componentId];
                }
                return _result;
            }
            Components.getById = getById;
            /**
             * @description Gets the component based on the component id.
             * @param {number} componentId The component id of the component to get.
             * @returns{Promise<Component>} A promise of component.
             */
            function getByIdAsync(componentId) {
                return new Promise(function (resolve, reject) {
                    resolve(pc.Components.getById(componentId));
                });
            }
            Components.getByIdAsync = getByIdAsync;
            /**
             * @description Gets component based on the code name.
             * @param {string} codeName The code name of the component to get.
             * @returns{Component} A component.
             */
            function getByCodeName(codeName) {
                var _result = null;
                if (_componentsByCodeName && _componentsByCodeName != null) {
                    _result = _componentsByCodeName[codeName];
                }
                return _result;
            }
            Components.getByCodeName = getByCodeName;
            /**
             * @description Gets the component based on the code name.
             * @param {string} codeName The code name of the component to get.
             * @returns{Promise<Component>} A promise of component.
             */
            function getByCodeNameAsync(codeName) {
                return new Promise(function (resolve, reject) {
                    resolve(pc.Components.getByCodeName(codeName));
                });
            }
            Components.getByCodeNameAsync = getByCodeNameAsync;
            /**
             * @description Sets the configuration for the specified component based on the code name and all children of the component.
             * @param {component} component The component to set the configuration for.
             * @param {number[]} skipChildComponentIds The componentIds to skip.
             */
            function setComponent(component, skipChildComponentIds) {
                if (component && component != null && skipChildComponentIds.indexOf(component.componentId) == -1) {
                    _componentsById[component.componentId] = component;
                    _componentsByCodeName[component.codeName] = component;
                    setEvents(component);
                    // Recursively set the children components.
                    if (component.children && component.children != null) {
                        for (var i = 0, count = component.children.length; i < count; ++i) {
                            setComponent(component.children[i], skipChildComponentIds);
                        }
                    }
                }
            }
            Components.setComponent = setComponent;
            /**
             * @description Sets the events tied to the specified component.
             * @param {component} component The component to set the event configuration for.
             */
            function setEvents(component) {
                var _setupEvent = function (eventData) {
                    if (eventData && eventData.eventName && eventData.function) {
                        EventBus.subscribe(eventData.eventName, eventData.function, null, eventData.settings);
                    }
                };
                if (component) {
                    if (component && component.mountEvent != null) {
                        _setupEvent(component.mountEvent);
                    }
                    if (component && component.unmountEvent != null) {
                        _setupEvent(component.unmountEvent);
                    }
                }
            }
            Components.setEvents = setEvents;
            /**
             * @description Publishes the unmount event for the specified component id.
             * @param {number} componentId The id of the component to unmount.
             */
            function unmount(componentId) {
                var _component = getById(componentId);
                if (_component.unmountEvent && _component.unmountEvent != null) {
                    pc.EventBus.publish(_component.unmountEvent.eventName, _component.unmountEvent.settings);
                }
            }
            Components.unmount = unmount;
        })(Components = pc.Components || (pc.Components = {}));
        /**
         * @description Provides functionality for managing events and the publish subscribe pattern.
         */
        var EventBus;
        (function (EventBus) {
            var _topics = {};
            /**
             * @description A class represents a topic.
             */
            var Topic = /** @class */ (function () {
                /**
                 * @description A constructor to create a topic.
                 * @param {any} context The optional context (this) with which to invoke the callback.
                 * @param {string} fn The function to invoke when a topic is published.
                 * @param {string} name The name of the topic.
                 * @param {any[]} args An array of arguments.
                 */
                function Topic(context, fn, name, args) {
                    this.args = args;
                    this.context = context;
                    this.fn = fn;
                    this.name = name;
                }
                return Topic;
            }());
            EventBus.Topic = Topic;
            /**
             * @description Gets all event data.
             * @returns {object} An object contains all the topics.
             */
            function dump() {
                return _topics;
            }
            EventBus.dump = dump;
            /**
             * @description Publishes to the provided topic with one or more arguments.
             * @param {string} topicName The topic to publish.
             * @param {any[]} args The array of arguments.
             */
            function publish(topicName, args) {
                if (topicName === void 0) { topicName = ''; }
                if (topicName && Array.isArray(_topics[topicName])) {
                    for (var _i = 0, _a = _topics[topicName]; _i < _a.length; _i++) {
                        var _topic = _a[_i];
                        var _function = GSS.common.getFunction(_topic.fn);
                        var _args = _topic.args || [];
                        if (args && args != null) {
                            Array.prototype.push.apply(_args, args);
                        }
                        if (_function) {
                            _function(_args);
                        }
                    }
                }
            }
            EventBus.publish = publish;
            /**
             * @description Subscribes to the provided topic, the given function along with an optional context.
             * @param {string} topicName The topic to subscribe to.
             * @param {string} fn The function to invoke when a topic is published.
             * @param {any} context The optional context (this) with which to invoke the callback.
             * @param {any[]} defaultArgs The aray of arguments.
             */
            function subscribe(topicName, fn, context, defaultArgs) {
                if (topicName === void 0) { topicName = ''; }
                if (topicName && fn && typeof topicName === 'string' && typeof fn === 'string') {
                    _topics[topicName] = _topics[topicName] || [];
                    return _topics[topicName].push(new Topic(context, fn, topicName, defaultArgs));
                }
                return null;
            }
            EventBus.subscribe = subscribe;
        })(EventBus = pc.EventBus || (pc.EventBus = {}));
        /**
         * @description Provides functionality for working with notifications.
         */
        var Notifications;
        (function (Notifications) {
            /**
             * @description A class containing default notification options.
             */
            var DefaultNotificationOptions = {
                closeButton: true,
                debug: false,
                extendedTimeOut: 1000,
                hideDuration: 1000,
                hideEasing: "swing",
                hideMethod: "fadeOut",
                newestOnTop: false,
                onclick: null,
                positionClass: "toast-top-right",
                preventDuplicates: false,
                progressBar: true,
                showDuration: 300,
                showEasing: "swing",
                showMethod: "fadeIn",
                timeOut: 5000
            };
            /**
             * @description A class containing notification options.
             */
            var NotificationOptions = /** @class */ (function () {
                function NotificationOptions() {
                }
                return NotificationOptions;
            }());
            Notifications.NotificationOptions = NotificationOptions;
            /**
             * @description An enum containing notification types.
             */
            var NotificationType;
            (function (NotificationType) {
                /**
                 * Defines the success notification type.
                 */
                NotificationType[NotificationType["Success"] = 0] = "Success";
                /**
                 * Defines the info notification type.
                 */
                NotificationType[NotificationType["Info"] = 1] = "Info";
                /**
                 * Defines the warning notification type.
                 */
                NotificationType[NotificationType["Warning"] = 2] = "Warning";
                /**
                 * Defines the error notification type.
                 */
                NotificationType[NotificationType["Error"] = 3] = "Error";
            })(NotificationType = Notifications.NotificationType || (Notifications.NotificationType = {}));
            /**
             * @description Shows a notification.
             * @param {string} content The content to display in the notification.
             * @param {NotificationType} type Optional notification type.
             * @param {NotificationOptions} options Optional notification options data.
             */
            // Change to content
            function showNotification(content, type, options) {
                if (type === void 0) { type = NotificationType.Success; }
                // Merge the notification options.
                var _options = $.extend({}, DefaultNotificationOptions, options);
                // Display the notification.
                switch (type) {
                    case NotificationType.Success: {
                        toastr.success(content, "", _options);
                        break;
                    }
                    case NotificationType.Info: {
                        toastr.info(content, "", _options);
                        break;
                    }
                    case NotificationType.Warning: {
                        toastr.warning(content, "", _options);
                        break;
                    }
                    case NotificationType.Error: {
                        toastr.error(content, "", _options);
                        break;
                    }
                    default: {
                        toastr.success(content, "", _options);
                        break;
                    }
                }
            }
            Notifications.showNotification = showNotification;
        })(Notifications = pc.Notifications || (pc.Notifications = {}));
        /**
         * @description Provides functionality for working with server requests.
         */
        var Request;
        (function (Request) {
            /**
             * @description Parameters name
             * @type {string}
             */
            Request.Parameters = {
                clientId: 'gssClientId',
                componentId: 'gssComponentId'
            };
            /**
             * @description A class contains request options
             */
            var RequestOptions = /** @class */ (function () {
                function RequestOptions() {
                }
                return RequestOptions;
            }());
            Request.RequestOptions = RequestOptions;
            /**
             * @description Generates an HTTP GET request.
             * @param {number} componentId The id of the component to generate the request for.
             * @param {string} url The url of the request.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function get(componentId, url, data, dataType, enableModalProgress) {
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                var _enableModalProgress = enableModalProgress === undefined ? false : enableModalProgress;
                var _setStatus = false;
                var _enableCache = false;
                if (_enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                var _data = setRequiredData(componentId, data);
                // Invoke the get.
                var _request = GSS.common.request(url, dataType, _enableCache).get(_data);
                return _request.then(
                // return ajax as success when request successful processes.
                function (data, textStatus, jqXHR) { return (void _data, textStatus, jqXHR); }, 
                // return ajax as fail when request got error while processing.
                function (jqXHR, status, error) {
                    var _errorData = { url: url, data: _data, method: 'pc.Request.get' };
                    pc.UI.setComponentContainerContent(componentId, jqXHR.responseText);
                    onFail(componentId, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Request.get = get;
            /**
             * @description Generates an HTTP GET request and returns a promise.
             * @param {number} componentId The id of the component to generate the request for.
             * @param {string} url The url of the request.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @param {RequestOptions} options Optional settings data.
             * @returns {Promise<Any>} A Promise.
             */
            function getAsync(componentId, url, data, dataType, options) {
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                if (options && options.showModalProgress) {
                    PortalContainer.progressShow();
                }
                var _data = setRequiredData(componentId, data);
                return new Promise(function (resolve, reject) {
                    var _xhr = new XMLHttpRequest();
                    _xhr.onreadystatechange = function () {
                        if (_xhr.readyState === 4) {
                            // Disable the modal progress if needed.
                            if (options && options.hideModalProgress) {
                                PortalContainer.progressHide();
                            }
                            switch (_xhr.status) {
                                case 401: {
                                    // Handle refreshing the current page if the user is not authenticated.
                                    // TODO: this should be made into a standard handler for re-usability.
                                    window.location.href = window.location.href;
                                }
                                case 403:
                                case 422:
                                case 500: {
                                    reject(_xhr.responseText);
                                }
                                default: {
                                    resolve(_xhr.responseText);
                                }
                            }
                        }
                    };
                    if (typeof (_data) !== 'string') {
                        _data = '?' + Object.keys(_data)
                            .map(function (key) {
                            return key + "=" + encodeURIComponent(_data[key]);
                        })
                            .join("&");
                    }
                    else {
                        _data = '?' + _data;
                    }
                    _xhr.open("GET", url + _data, true);
                    _xhr.setRequestHeader("Content-type", dataType);
                    _xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                    _xhr.send(null);
                });
            }
            Request.getAsync = getAsync;
            /**
             * @description Generates an HTTP POST request and returns a promise.
             * @param {number} componentId The id of the component to generate the request for.
             * @param {string} url The url of the request.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @param {RequestOptions} options Optional settings data.
             * @param {string} overrideComponentName Optional override component name to use for auditing.
             * @returns {Promise<Any>} A Promise.
             */
            function postAsync(componentId, url, data, dataType, options, overrideComponentName) {
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                if (options && options.showModalProgress) {
                    PortalContainer.progressShow();
                }
                var _data = setRequiredData(componentId, data);
                return new Promise(function (resolve, reject) {
                    var _xhr = new XMLHttpRequest();
                    _xhr.onreadystatechange = function () {
                        if (_xhr.readyState === 4) {
                            // Disable the modal progress if needed.
                            if (options && options.hideModalProgress) {
                                PortalContainer.progressHide();
                            }
                            switch (_xhr.status) {
                                case 401: {
                                    // Handle refreshing the current page if the user is not authenticated.
                                    // TODO: this should be made into a standard handler for re-usability.
                                    window.location.href = window.location.href;
                                }
                                case 403:
                                case 422:
                                case 500: {
                                    reject(_xhr.responseText);
                                }
                                default: {
                                    resolve(_xhr.responseText);
                                }
                            }
                        }
                    };
                    if (dataType === 'application/json' && typeof (_data) !== 'string') {
                        _data = JSON.stringify(_data);
                    }
                    _xhr.open("POST", url, true);
                    _xhr.setRequestHeader("Content-type", dataType);
                    _xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                    _xhr.setRequestHeader("X-AuditingComponentName", GSS.common.isNotNullOrEmpty(overrideComponentName) ? overrideComponentName : GSS.common.getCurrentComponentName());
                    _xhr.send(_data);
                });
            }
            Request.postAsync = postAsync;
            /**
             * @description Generates a component url for the specified component id.  This will also use the optional data parameter to add to the query string.
             * @param {number} componentId The id of the component to generate the url for.
             * @param {any} data An optional parameter that if included will be used to append to the query string.
             * @return {string} A url that will invoke the HTTP GET method for a specified component.
            **/
            function getComponentUrl(componentId, data) {
                var _data = data || '';
                _data = pc.Request.setRequiredData(componentId, _data);
                if (typeof (_data) === 'object') {
                    _data = GSS.common.encodeAndParameterize(_data);
                }
                return '../_Portal/Component?' + _data;
            }
            Request.getComponentUrl = getComponentUrl;
            /**
             * @description Extends the incoing data object with the required request data.
             * @param {number} componentId The id of the component to generate the url for.
             * @param {any} data The data object to extend.
             * @return {any} The data extended with required request data.
             */
            function setRequiredData(componentId, data) {
                var _compId = componentId;
                if (!_compId || _compId === null) {
                    var _el = document.querySelector('div[' + pc.UI.Attributes.componentId + ']');
                    if (_el && _el !== null) {
                        _compId = +_el.getAttribute(pc.UI.Attributes.componentId);
                    }
                }
                var _clientId = GSS.common.getAttributeValue(GSS.widget.attributeNames.clientId, null);
                if (_clientId) {
                    data = GSS.common.extendValue(data, Request.Parameters.clientId, _clientId);
                }
                data = GSS.common.extendValue(data, Request.Parameters.componentId, _compId);
                data = GSS.common.addAntiForgeryToken(data);
                return data;
            }
            Request.setRequiredData = setRequiredData;
            /**
             * @description Function called when an error occurs.
             * @param {number} componentId The id of the component.
             * @param {any} data The data to display on error..
             */
            function onFail(componentId, data) {
                var _componentName = '[UNDEFINED COMPONENT]';
                if (componentId) {
                    var _component = pc.Components.getById(componentId);
                    if (_component && _componentName) {
                        _componentName = _component.displayName;
                    }
                }
                // Commented out, the notify widget error is not currently setup for components properly, plus we need to provide more useful information.
                // notifyWidgetError(componentId, 'GCP Portal Error - ' + _componentName, data);
            }
            /**
             * @description Sends an error notification about a widget error.
             * @param {number} componentId The id of the component that errored.
             * @param {any} subject The notification subject.
             * @param {any} errorData The error details.
             */
            function notifyWidgetError(componentId, subject, errorData) {
                // Clear the content before POSTing data
                var _componentName = '[UNDEFINED]';
                setTimeout(function () {
                    var _data = errorData;
                    GSS.common.extendValue(_data, 'GCP Portal Error - ' + GSS.widget.widgetErrorSettings.subjectParamName, subject);
                    _data = pc.Request.setRequiredData(componentId, _data);
                    $.ajax({ type: 'POST', url: GSS.widget.widgetErrorSettings.url, data: jQuery.param(_data), cache: false });
                }, 1);
            }
            Request.notifyWidgetError = notifyWidgetError;
            /**
             * @description Generates an http post request.
             * @param {number} componentId The id of the component to generate the url for.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function post(componentId, url, data, dataType, timeout, contentType) {
                if (componentId === undefined) {
                    throw new Error('componentId is undefined');
                }
                if (url === undefined) {
                    throw new Error("url is undefined.");
                }
                if (dataType === undefined) {
                    throw new Error("dataType is undefined.");
                }
                var _enableModalProgress = false;
                var _enableCache = false;
                var _data = setRequiredData(componentId, data);
                if (_enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                //Create an ajax call to controller and return request as Promise object
                var _request = GSS.common.request(url, dataType, _enableCache, timeout, contentType).post(_data);
                // process Promise object
                return _request.then(
                // return ajax success
                function (data, textStatus, jqXHR) {
                    return (void _data, textStatus, jqXHR);
                }, 
                // return ajax fail when something went wrong.
                function (jqXHR, status, error) {
                    var _errorData = { url: url, data: _data, method: 'pc.Request.post' };
                    pc.UI.setComponentContainerContent(componentId, jqXHR.responseText);
                    onFail(componentId, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Request.post = post;
        })(Request = pc.Request || (pc.Request = {}));
        /**
         * @description Provides functionality for working with the portal container UI.
         */
        var UI;
        (function (UI) {
            /**
             * @description Defines the different attributes.
             * @type {object}
             */
            UI.Attributes = {
                componentId: 'data-gss-componentId',
                codeName: 'data-gss-componentCodeName',
                tileHeight: 'data-gss-widget-height',
                tileWidth: 'data-gss-widget-width',
                type: 'data-gss-componentType',
                autoDisable: 'data-gss-auto-disable',
                disableInterval: 'data-gss-disable-interval'
            };
            /**
             * @description Defines the different attribute values.
             * @type {object}
             */
            UI.Values = {
                tileClass: 'gss-tile',
                tileName: 'divComponent'
            };
            /**
             * @description Creates the container for the specified component.
             * @param {Component} component The component to put in the container.
             * @param {string} content The content in the container.
             * @return {string} The content wrapped with container.
             */
            function createContainer(component, content) {
                if (content === void 0) { content = ''; }
                var _result = '<div></div>';
                if (component && component != null) {
                    var _idAttr = "id=\"".concat(component.componentId, "\"");
                    var _componentIdAttr = "".concat(UI.Attributes.componentId, "=\"").concat(component.componentId, "\"");
                    var _codeNameAttr = "".concat(UI.Attributes.codeName, "=\"").concat(component.codeName, "\"");
                    var _typeAttr = "".concat(UI.Attributes.type, "=\"").concat(component.type, "\"");
                    _result = "<div ".concat(_idAttr, " ").concat(_componentIdAttr, " ").concat(_codeNameAttr, " ").concat(_typeAttr, ">").concat(content, "</div>");
                    // TODO: Define additional attributes here based on the type of component.
                }
                return _result;
            }
            UI.createContainer = createContainer;
            /**
             * @description Creates the tile for the specified component.
             * @param {Component} component The component to put in the tile.
             * @param {string} content The content in the tile.
             * @return {string} The content wrapped with tile.
             */
            function createTile(component, content) {
                if (content === void 0) { content = ''; }
                var _result = '<div></div>';
                if (component && component != null) {
                    var _idAttr = "id=\"".concat(component.componentId, "\"");
                    var _componentIdAttr = "".concat(UI.Attributes.componentId, "=\"").concat(component.componentId, "\"");
                    var _codeNameAttr = "".concat(UI.Attributes.codeName, "=\"").concat(component.codeName, "\"");
                    var _typeAttr = "".concat(UI.Attributes.type, "=\"").concat(component.type, "\"");
                    var _classAttr = "class=\"".concat(UI.Values.tileClass, "\"");
                    var _tileNameAttr = "data-gss-name=\"".concat(UI.Values.tileName, "\"");
                    var _heightAttr = "".concat(UI.Attributes.tileHeight, "=\"").concat(component.height || 1, "\"");
                    var _widthAttr = "".concat(UI.Attributes.tileWidth, "=\"").concat(component.width || 1, "\"");
                    _result = "<div ".concat(_idAttr, " ").concat(_componentIdAttr, " ").concat(_codeNameAttr, " ").concat(_typeAttr, " ").concat(_classAttr, " ").concat(_tileNameAttr, " ").concat(_heightAttr, " ").concat(_widthAttr, ">").concat(content, "</div>");
                    // TODO: Define additional attributes here based on the type of component.
                }
                return _result;
            }
            UI.createTile = createTile;
            /**
            * @description Hides components which are failed to load due to script load failures
            * @param {number[]} skipChildComponentIds The componentIds to skip.
             */
            function disableComponent(skipChildComponentIds) {
                skipChildComponentIds.forEach(function (componentId) {
                    var _container = getComponentIdContainer(componentId);
                    if (_container && _container !== null) {
                        _container.parent().parent().hide(true);
                    }
                });
            }
            UI.disableComponent = disableComponent;
            /**
             * @description Gets the component container for the specified component id.
             * @param {number} componentId The id of the component .
             * @return {jQuery} The jQuery object.
             */
            function getComponentIdContainer(componentId) {
                if (componentId != null) {
                    return $('[' + UI.Attributes.componentId + '="' + componentId + '"]');
                }
                else {
                    return null;
                }
            }
            UI.getComponentIdContainer = getComponentIdContainer;
            /**
             * @description Gets the component container for the specified component code name.
             * @param {string} name The code name of the component .
             * @return {jQuery} The jQuery object.
             */
            function getComponentNameContainer(name) {
                if (name != null) {
                    return $('[' + UI.Attributes.codeName + '="' + name + '"]');
                }
                else {
                    return null;
                }
            }
            UI.getComponentNameContainer = getComponentNameContainer;
            /**
             * @description Sets the component container content.
             * @param {number} componentId The id of the component .
             * @param {string} content The content to set.
             */
            function setComponentContainerContent(componentId, content) {
                var _container = getComponentIdContainer(componentId);
                if (_container && _container !== null) {
                    _container.html(content);
                }
            }
            UI.setComponentContainerContent = setComponentContainerContent;
            /**
             * @description Sets the main content container for the component management pages.
             * @param {any} data The data that represents the main content.
             * @param {string} element The element to hold the content.
             */
            function setMainContent(data, element) {
                // <summary>Sets the main content container for the component management pages.</summary>
                // <param name="data">The data that represents the main content.</param>
                GSS.widget.getElementByGssName(element).html(data);
            }
            UI.setMainContent = setMainContent;
            /**
             * Initializes the Quill text editor.
             * @param id The id of the editor.
             * @param toolbarOptions Optional toolbar options.
             * @param readOnly Optional read only flag.
             * @param direction Optional direction text.
             */
            function initializeQuillEditor(rawFieldId, encodedFieldId, toolbarOptions, readOnly, direction, height) {
                if (toolbarOptions === void 0) { toolbarOptions = null; }
                if (readOnly === void 0) { readOnly = false; }
                if (direction === void 0) { direction = null; }
                if (height === void 0) { height = null; }
                var _editorId = 'editor_' + rawFieldId;
                var _quill = new Quill('#' + _editorId, {
                    bounds: '#' + _editorId,
                    modules: {
                        toolbar: readOnly ? false : toolbarOptions
                    },
                    theme: 'snow',
                    readOnly: readOnly
                });
                if (height) {
                    _quill.container.style.height = height + 'px';
                }
                var _keyboard = _quill.getModule('keyboard');
                delete _keyboard.bindings[9];
                _quill.on('text-change', function (delta) {
                    var _textHtml = _quill.container.querySelector('.ql-editor').innerHTML;
                    $('#' + rawFieldId).val(_textHtml);
                    if (encodedFieldId) {
                        $('#' + encodedFieldId).val(encodeURIComponent(_textHtml));
                    }
                });
                if (direction == 'RTL') {
                    $(_quill.container.querySelector('.ql-editor')).css('direction', 'rtl');
                    $(_quill.container.querySelector('.ql-editor')).css('text-align', 'right');
                }
                $('.ql-bold').attr('aria-label', 'bold');
                $('.ql-italic').attr('aria-label', 'italic');
                $('.ql-underline').attr('aria-label', 'underline');
                $('.ql-link').attr('aria-label', 'link');
            }
            UI.initializeQuillEditor = initializeQuillEditor;
        })(UI = pc.UI || (pc.UI = {}));
        /**
         * @description This module is for demo purposes only and can be removed later.
         */
        var Test;
        (function (Test) {
            function getByIdAsyncTest(componentId) {
                return __awaiter(this, void 0, void 0, function () {
                    var _value;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, pc.Components.getByIdAsync(componentId)];
                            case 1:
                                _value = _a.sent();
                                void 0;
                                return [2 /*return*/, true];
                        }
                    });
                });
            }
            Test.getByIdAsyncTest = getByIdAsyncTest;
            function getAsyncTest() {
                return __awaiter(this, void 0, void 0, function () {
                    var _urlOk, _urlError, _urlValidationError, e_1, e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _urlOk = "/api/v1/maintenance/ok";
                                _urlError = "/api/v1/maintenance/error";
                                _urlValidationError = "/api/v1/maintenance/validationError";
                                return [4 /*yield*/, pc.Request.getAsync(1, _urlOk, null, "application/json")
                                        .then(function (result) {
                                        void 0;
                                        void 0;
                                    })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 4, , 5]);
                                return [4 /*yield*/, pc.Request.getAsync(1, _urlError, null, "application/json")
                                        .then(function (result) {
                                        void 0;
                                        void 0;
                                    })];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                e_1 = _a.sent();
                                void 0;
                                void 0;
                                return [3 /*break*/, 5];
                            case 5:
                                _a.trys.push([5, 7, , 8]);
                                return [4 /*yield*/, pc.Request.getAsync(1, _urlValidationError, null, "application/json")
                                        .then(function (result) {
                                        void 0;
                                        void 0;
                                    })];
                            case 6:
                                _a.sent();
                                return [3 /*break*/, 8];
                            case 7:
                                e_2 = _a.sent();
                                void 0;
                                void 0;
                                return [3 /*break*/, 8];
                            case 8: return [2 /*return*/];
                        }
                    });
                });
            }
            Test.getAsyncTest = getAsyncTest;
            function getAsyncAllTest() {
                return __awaiter(this, void 0, void 0, function () {
                    var _urlOk, _urlError, _urlValidationError, _urlWithData, _result1, _result2, _result3, _result4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _urlOk = "/api/v1/maintenance/ok";
                                _urlError = "/api/v1/maintenance/error";
                                _urlValidationError = "/api/v1/maintenance/validationError";
                                _urlWithData = "/api/v1/maintenance/okData";
                                _result1 = pc.Request.getAsync(1, _urlOk, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result2 = pc.Request.getAsync(1, _urlError, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result3 = pc.Request.getAsync(1, _urlValidationError, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result4 = pc.Request.getAsync(1, _urlWithData, "clientId=1&codeName=testCodeName", "application/x-www-form-urlencoded")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                void 0;
                                return [4 /*yield*/, Promise.all([_result1, _result2, _result3, _result4])];
                            case 1:
                                _a.sent();
                                void 0;
                                return [2 /*return*/];
                        }
                    });
                });
            }
            Test.getAsyncAllTest = getAsyncAllTest;
            function postAsyncAllTest() {
                return __awaiter(this, void 0, void 0, function () {
                    var _urlOk, _urlError, _urlValidationError, _urlWithData, _result1, _result2, _result3, _result4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _urlOk = "/api/v1/maintenance/ok";
                                _urlError = "/api/v1/maintenance/error";
                                _urlValidationError = "/api/v1/maintenance/validationError";
                                _urlWithData = "/api/v1/maintenance/okData";
                                _result1 = pc.Request.postAsync(1, _urlOk, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result2 = pc.Request.postAsync(1, _urlError, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result3 = pc.Request.postAsync(1, _urlValidationError, null, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                _result4 = pc.Request.postAsync(1, _urlWithData, { clientId: 1, codeName: 'testCodeName' }, "application/json")
                                    .then(function (result) {
                                    void 0;
                                    void 0;
                                })
                                    .catch(function (error) {
                                    void 0;
                                    void 0;
                                });
                                void 0;
                                return [4 /*yield*/, Promise.all([_result1, _result2, _result3, _result4])];
                            case 1:
                                _a.sent();
                                void 0;
                                return [2 /*return*/];
                        }
                    });
                });
            }
            Test.postAsyncAllTest = postAsyncAllTest;
        })(Test = pc.Test || (pc.Test = {}));
    })(pc = GSS.pc || (GSS.pc = {}));
    /**
     * @description Provides functionality for working with widget based portal container.
     */
    var PortalContainer;
    (function (PortalContainer) {
        /**
       * @description Provides functionality for working with common methods.
       */
        var Credential;
        (function (Credential) {
            ;
            // get new token and env from the server
            function getInfo() {
                var _def = $.Deferred();
                var _session = new GSS.common.session(true);
                var _data = {};
                var _reqObject = {
                    url: PortalContainer.url.GetToken,
                    returnType: GSS.common.returnType.Json,
                    data: _data
                };
                GSS.admintools.service.get(_reqObject, GSS.common.modalProgress.Enable)
                    .done(function (data) {
                    var currentDate = new Date();
                    var _response = { id: PortalContainer.attributes.userDataId, value: currentDate.toISOString(), values: { token: data.token, apiUrl: data.apiUrl, samTeamsGatewayUrl: data.samTeamsGatewayUrl } };
                    _session.upsert(_response);
                    _def.resolve(_response.values);
                }).fail(function (err) { _def.reject(err); });
                return _def.promise();
            }
            Credential.getInfo = getInfo;
            // get existing or new request that will retrieve token and env accordingly base on time limit
            function manageInfo() {
                var _def = $.Deferred();
                var _session = new GSS.common.session(true);
                var _sessionItem = _session.getItem(PortalContainer.attributes.userDataId);
                if (_sessionItem === undefined || _sessionItem === null) {
                    getInfo.call(this).done(function (data) {
                        _def.resolve(data);
                    }).fail(function (err) { return _def.reject(err.Message); });
                }
                else {
                    var diffMili = new Date().getTime() - new Date(_sessionItem.value).getTime();
                    if ((diffMili / 1000 / 60) >= PortalContainer.attributes.tokenTimeoutInMinutes) {
                        sessionStorage.removeItem(PortalContainer.attributes.userDataId);
                        getInfo.call(this).done(function (data) {
                            _def.resolve(data);
                        }).fail(function (err) { return _def.reject(err.Message); });
                    }
                    else {
                        _def.resolve(_sessionItem.values);
                    }
                }
                return _def.promise();
            }
            Credential.manageInfo = manageInfo;
        })(Credential = PortalContainer.Credential || (PortalContainer.Credential = {}));
        var apiRequest;
        (function (apiRequest) {
            function request(url, token, apiVersion, overrideComponentName) {
                if (apiVersion === void 0) { apiVersion = ''; }
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                var _apiVersion = apiVersion.length > 0 ? apiVersion : '';
                var _ajax = function (requestType, data) {
                    var _requestData = {
                        type: requestType,
                        url: url,
                        headers: { 'Authorization': "Bearer ".concat(token), 'api-version': _apiVersion, 'X-AuditingComponentName': GSS.common.isNotNullOrEmpty(overrideComponentName) ? overrideComponentName : GSS.common.getCurrentComponentName() },
                        crossDomain: true,
                        data: data,
                        cache: false,
                        contentType: "application/json",
                        dataType: "text",
                    };
                    return $.ajax(_requestData);
                };
                var _delete = function (data) {
                    if (data === undefined) {
                        void 0;
                    }
                    return _ajax("DELETE", data);
                };
                var _get = function (data) {
                    return _ajax("GET", data);
                };
                var _post = function (data) {
                    if (data === undefined) {
                        void 0;
                    }
                    return _ajax("POST", data);
                };
                var _put = function (data) {
                    if (data === undefined) {
                        void 0;
                    }
                    return _ajax("PUT", data);
                };
                return {
                    get: _get,
                    post: _post,
                    delete: _delete,
                    put: _put
                };
            }
            apiRequest.request = request;
        })(apiRequest = PortalContainer.apiRequest || (PortalContainer.apiRequest = {}));
        /**
         * @description Provides functionality for working with history.
         */
        var History;
        (function (History) {
            /**
             * @property A value indicates whether the history state is changed manually or not.
             */
            History.manualStateChange = false;
            /**
             * @description Function called to push state using History.
             * @param {any} dashboardWidgetId The unique widget instance identifier.
             * @param {any} getUrl The url to get the initial data from.
             * @param {any} options The option data to send in the ajax get request.
             * @param {any} functionData The data will be used when clicking back button.
             * @param {any} setStatus Set the status.
             */
            function pushStateHistoryManually(dashboardWidgetId, getUrl, options, functionData, setStatus) {
                /// <summary>Function called to push state using History.</summary>
                GSS.PortalContainer.History.manualStateChange = true;
                pushStateHistory(dashboardWidgetId, getUrl, options, functionData, setStatus);
            }
            History.pushStateHistoryManually = pushStateHistoryManually;
            /**
             * @description Function called to push state using History.
             * @param {any} dashboardWidgetId The unique widget instance identifier.
             * @param {any} getUrl The url to get the initial data from.
             * @param {any} options The option data to send in the ajax get request.
             * @param {any} functionData The data will be used when clicking back button.
             * @param {any} setStatus Set the status.
             */
            function pushStateHistory(dashboardWidgetId, getUrl, options, functionData, setStatus) {
                if (GSS.portal.history.enableHistory) {
                    var data = {
                        _uniqueId: (new Date).getTime(),
                        widget: dashboardWidgetId,
                        url: getUrl,
                        opt: options,
                        functionData: functionData,
                        setStatus: setStatus,
                        replaced: false
                    };
                    window.History.pushState(data, document.title);
                }
            }
            History.pushStateHistory = pushStateHistory;
            /**
             * @description Function called to replace history state.
             */
            function replaceState() {
                if (GSS.portal.history.enableHistory) {
                    window.History.replaceState({ _uniqueId: (new Date).getTime() }, document.title, location.pathname + location.search);
                }
            }
            History.replaceState = replaceState;
            /**
             * @description Function called to handle state change event.
             * @param {any} e The event triggered.
             */
            function handleStateChangeEvent(e) {
                if (GSS.portal.history.initialLoad == true) {
                    // Don't pull from state if it is the initial full app load
                    GSS.portal.history.initialLoad = false;
                    return;
                }
                else {
                    var state = window.History.getState();
                    //goo into normal mode if you change it manually or you have no stateChangeUrl (saying you want to treat it normally)
                    if (History.manualStateChange == true || (state.data.functionData != undefined && state.data.functionData.stateChangeUrl == undefined)) {
                        if (state.data.url) {
                            var _completeFunction = GSS.common.getFunction(state.data.functionData.functionName);
                            if (state.data.functionData.beforeFunctionName) {
                                GSS.common.getFunction(state.data.functionData.beforeFunctionName).apply(this, state.data.functionData.beforeFunctionArgs);
                            }
                            PortalContainer.getPartial(state.data.widget, state.data.url, state.data.opt, state.data.setStatus, _completeFunction);
                        }
                        else {
                            window.location.href = state.url;
                        }
                    }
                    else {
                        // Back button was pressed
                        if (state.data.functionData != undefined && state.data.functionData.stateChangeUrl) { //Not sure about this
                            var _completeFunction = GSS.common.getFunction(state.data.functionData.stateChangeFunctionName);
                            if (state.data.functionData.beforeStateChangeFunctionName) {
                                GSS.common.getFunction(state.data.functionData.beforeStateChangeFunctionName).apply(this, state.data.functionData.beforeStateChangeFunctionArgs);
                            }
                            PortalContainer.getPartial(state.data.widget, state.data.functionData.stateChangeUrl, state.data.functionData.stateChangeOpt, state.data.functionData.stateChangeSetStatus, _completeFunction);
                        }
                        else {
                            // Since when we create the new survey, we reinitialize the full app, its loosing the history,
                            // so we have to go back using the window.history.back, when the browser back button is pressed
                            var _urlSubString = 'newInstrumentVersionIdString';
                            if (state.url.indexOf(_urlSubString) != -1) {
                                window.history.back();
                            }
                            else {
                                window.location.href = state.url;
                            }
                        }
                    }
                    History.manualStateChange = false;
                }
            }
            History.handleStateChangeEvent = handleStateChangeEvent;
        })(History = PortalContainer.History || (PortalContainer.History = {}));
        /**
         * @property The file name
         * @type {string}
         */
        PortalContainer.fileName = 'GSS.portalContainer.js';
        /**
         * @property An object that contains the common communication bus action names.
         * @type {object}
         */
        PortalContainer.actionNames = {
            portalMessage: 'portalMessage',
            resize: 'resize',
            gssWizardSectionError: 'GssWizardSectionError' /* Used by GSS based wizards. */
        };
        /**
         * @property An object that contains the error types.
         * @type {object}
         */
        PortalContainer.errorType = {
            init: 'init',
            generic: 'generic',
            undefined: 'Undefined'
        };
        /**
         * @property Defines the standard fields for a message item.
         * @type {object}
         */
        PortalContainer.messageFields = {
            action: 'action',
            dashboardWidgetId: GSS.widget.uniqueWidgetIdName,
            value: 'value',
            widgetCodeName: 'widgetCodeName'
        };
        /**
         * @property Defines the modal related values.
         * @type {object}
         */
        PortalContainer.modalValues = {
            container: 'divGssModalContainer'
        };
        /**
         * @property Defines the standard fields for a message item.
         * @type {object}
         */
        PortalContainer.portalMessageFields = {
            target: 'target',
            type: 'type',
            value: 'value'
        };
        /**
         * @property Defines the different portal message types.
         * @type {object}
         */
        PortalContainer.portalMessageType = {
            error: 'error',
            information: 'info',
            warning: 'warning',
            valid: 'valid'
        };
        /**
         * @property Defines the standard request parameters for any widget request.
         * @type {object}
         */
        PortalContainer.requestFields = {
            clientId: 'gssClientId',
            componentId: 'gssComponentId',
            dashboardWidgetId: GSS.widget.uniqueWidgetIdName,
            disablePortalInject: 'disablePortalInject',
            height: 'height',
            locale: 'locale',
            title: 'title',
            widgetCodeName: 'widgetCodeName',
            width: 'width'
        };
        /**
         * @property Defines the standard response fields for any widget response.
         * @type {object}
         */
        PortalContainer.responseFields = {
            content: 'content',
            dashboardWidgetId: GSS.widget.uniqueWidgetIdName,
            messages: 'messages',
            navigationItems: 'navItems',
            title: 'title',
        };
        /**
         * @property A list of functions that get alerted when a message is queued for the communication bus
         * @type {Array}
         */
        PortalContainer.subscriptions = new Array();
        /**
         * @property An object that contains url values.
         * @type {object}
         */
        PortalContainer.url = {
            /// <summary>An object that contains url values.</summary>
            applicationAsync: '../_Portal/ApplicationAsync',
            getWidgetSettings: '../_Portal/GetWidgetSettings',
            setUserWidgetSettings: '../_Portal/SetUserWidgetSettings',
            updateUserWidgetSetting: '../_Portal/UpdateUserWidgetSetting',
            GetToken: '../_Portal/Token',
        };
        /**
         * @property Defines the different states that a widget can be in.
         * @type {object}
         */
        PortalContainer.widgetStatus = {
            available: 'available',
            busy: 'busy',
            error: 'error',
            undefined: 'Undefined'
        };
        /**
        * @property Defines the different attributes.
        * @type {object}
        */
        PortalContainer.attributes = {
            userDataId: '__user_data',
            tokenTimeoutInMinutes: 5,
        };
        /**
         * @description Consumes the incoming message for the portal container to handle.
         * @param {any} message The message to consume.
         */
        function consumeMessage(message) {
            /// Determine if the incoming message needs to be handled based on the action name value.
            if (!message) {
                return false;
            }
            var _action = message[PortalContainer.messageFields.action];
            var _value = message[PortalContainer.messageFields.value];
            if (_action === PortalContainer.actionNames.portalMessage) {
                GSS.messaging.empty(_value);
                GSS.messaging.display(_value);
            }
        }
        PortalContainer.consumeMessage = consumeMessage;
        /**
         * @description Helper function used to create a message object for the communication bus.
         * @param {any} dashboardWidgetId The unique identifier of the widget that the event is triggered for.
         * @param {any} action The name of the action for the message
         * @param {any} options The object that represents the value for the message.
         */
        function createMessage(dashboardWidgetId, action, value) {
            var _message = {};
            _message[PortalContainer.messageFields.action] = action;
            _message[PortalContainer.messageFields.dashboardWidgetId] = dashboardWidgetId;
            _message[PortalContainer.messageFields.value] = value;
            if (dashboardWidgetId) {
                _message[PortalContainer.messageFields.widgetCodeName] = GSS.widget.getWidgetName(dashboardWidgetId);
            }
            return _message;
        }
        PortalContainer.createMessage = createMessage;
        /**
         * @description Gets the widget Height based on the specified unique widget identifier.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         */
        function getTileHeight(dashboardWidgetId) {
            var _container = GSS.widget.getWidgetContainer(dashboardWidgetId).closest('[' + GSS.widget.attributeNames.gssElementName + '="divWidget"]');
            var _height = _container.attr(GSS.widget.attributeNames.dashboardWidgetHeight);
            return _height;
        }
        PortalContainer.getTileHeight = getTileHeight;
        /**
         * @description Gets the widget Width based on the specified unique widget identifier.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         */
        function getTileWidth(dashboardWidgetId) {
            var _container = GSS.widget.getWidgetContainer(dashboardWidgetId).closest('[' + GSS.widget.attributeNames.gssElementName + '="divWidget"]');
            var _width = $(_container).attr(GSS.widget.attributeNames.dashboardWidgetWidth);
            return _width;
        }
        PortalContainer.getTileWidth = getTileWidth;
        /**
         * @description Gets the widget configuration id based on the specified element.
         * @param {any} el The element to find the closes widget container for.
         * @returns {any} The dashboard widget id.
         */
        function getDashboardWidgetId(el) {
            if (!el) {
                return $('[' + GSS.widget.attributeNames.gssElementName + '="divWidget"]').first().attr(GSS.widget.attributeNames.dashboardWidgetId);
            }
            else {
                var _value = $(el).attr(GSS.widget.attributeNames.dashboardWidgetId);
                if (!_value) {
                    _value = $(el).closest('[' + GSS.widget.attributeNames.gssElementName + '="divWidget"]').attr(GSS.widget.attributeNames.dashboardWidgetId);
                }
                return _value;
            }
        }
        PortalContainer.getDashboardWidgetId = getDashboardWidgetId;
        /**
         * @description Gets the full application url for the dashboard widget and uses the data to create a query string.
         * @param {any} dashboardWidgetId The id of the dashboard widget.
         * @param {any} data The optional data to append to the url.
         * @returns {any} The full app url.
         */
        function getFullAppUrl(dashboardWidgetId, data) {
            var _data = data || '';
            _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
            if (typeof (_data) === 'object') {
                _data = GSS.common.encodeAndParameterize(_data);
            }
            return '../_Portal/ApplicationAsync?' + _data;
        }
        PortalContainer.getFullAppUrl = getFullAppUrl;
        /**
         * @description Attempts to get the language cookie value, if that doesn't work then it reads from the dropdown.Otherwise it returns en-US
         * @returns {any} The language name.
         */
        function getSiteLanguage() {
            /// <summary>Attempts to get the language cookie value, if that doesn't work then it reads from the dropdown.
            /// Otherwise it returns en-US </summary>
            var _language = GSS.common.getCookieValue("user.language");
            if (_language == null) {
                // Try to get the language from the dropdown menu
                _language = $("body").attr("lang");
            }
            return _language || "en-US";
        }
        PortalContainer.getSiteLanguage = getSiteLanguage;
        /**
         * @description Gets the widget settings for the specified dashboard widget id.
         * @param {any} dashboardWidgetId The dashboard widget id to get the settings for.
         * @param {any} successFunc Function called when the async request completes.
         */
        function getWidgetSettings(dashboardWidgetId, successFunc) {
            var _data = {};
            _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
            var _result = null;
            $.ajax({ type: 'GET', url: PortalContainer.url.getWidgetSettings, data: _data, cache: false, dataType: 'json' })
                .always(function (data) {
                if (successFunc && typeof (successFunc) === 'function') {
                    if (data) {
                        // The expected response for this is currently a JS Object.
                        var _result_1 = null;
                        if (typeof (data) === 'string') {
                            _result_1 = JSON.parse(data);
                        }
                        else {
                            _result_1 = data;
                        }
                        successFunc(_result_1);
                    }
                    else {
                        successFunc(null);
                    }
                }
            });
        }
        PortalContainer.getWidgetSettings = getWidgetSettings;
        /**
         * @description Initializes a widget full application.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} getUrl The url to get the initial widget state from.
         * @param {any} options The option data to send in the ajax get request.
         * @param {any} onCompleteFunc The function will be called after the app is initialized.
         */
        function initializeApp(dashboardWidgetId, getUrl, options, onCompleteFunc) {
            var _data = options || {};
            try {
                // Update the status to 'busy'.
                PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.busy);
                // Ensure that the required data has been set.
                _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                if (typeof (_data) !== "string") {
                    _data = jQuery.param(_data);
                }
                // Invoke the http get.
                $.ajax({ type: 'GET', url: getUrl, data: _data, cache: false })
                    .done(function (data) {
                    PortalContainer.setApp(data, dashboardWidgetId);
                    // Set the status to available.
                    PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.available);
                })
                    .always(function () {
                    if (onCompleteFunc) {
                        if (typeof (onCompleteFunc) === "function") {
                            onCompleteFunc();
                        }
                        else if (typeof (onCompleteFunc) === "string") {
                            GSS.common.getFunction(onCompleteFunc)();
                        }
                    }
                    PortalContainer.progressHide();
                })
                    .fail(function (jqXHR, status, error) {
                    var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'initializeApp');
                    PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.init, _errorData);
                });
            }
            catch (ex) {
                var _errorData = PortalContainer.setErrorData(ex.message, PortalContainer.fileName, 'initializeApp');
                PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.init, _errorData);
            }
        }
        PortalContainer.initializeApp = initializeApp;
        /**
         * @description Initializes a widget tile.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} getUrl The url to get the initial widget state from.
         * @param {any} options The option data to send in the ajax get request.
         * @param {any} onCompleteFunc The function will be called after the tile is initialized.
         */
        function initializeTile(dashboardWidgetId, getUrl, options, onCompleteFunc) {
            var _data = options || {};
            try {
                // Update the status to 'busy'.
                PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.busy);
                // Ensure that the required data has been set.
                _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                // Invoke the http get.
                $.ajax({ type: 'GET', url: getUrl, data: jQuery.param(_data), cache: false })
                    .done(function (data) {
                    // Update the content for the widget.
                    PortalContainer.setTile(data, dashboardWidgetId);
                    // Set the status to available.
                    PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.available);
                })
                    .always(function () {
                    if (onCompleteFunc) {
                        if (typeof (onCompleteFunc) === "function") {
                            onCompleteFunc();
                        }
                        else if (typeof (onCompleteFunc) === "string") {
                            GSS.common.getFunction(onCompleteFunc)();
                        }
                    }
                })
                    .fail(function (jqXHR, status, error) {
                    var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'initializeTile');
                    PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.init, _errorData);
                });
            }
            catch (ex) {
                var _errorData = PortalContainer.setErrorData(ex.message, PortalContainer.fileName, 'initializeTile');
                PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.init, _errorData);
            }
        }
        PortalContainer.initializeTile = initializeTile;
        /**
         * @deprecated Obsolete Use Request.getByEvent Instead
         */
        function get(el, url, data, dataType, cache) {
            PortalContainer.progressShow();
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            var _data = PortalContainer.setRequiredData(_dashboardWidgetId, data);
            // Create an ajax call to controller and return request as Promise object
            var request = GSS.common.request(url, dataType, cache).get(_data);
            // process Promise object
            return request.then(
            // return ajax success
            function (data, textStatus, jqXHR) {
                // Re-render the incoming contents.
                PortalContainer.progressHide();
                return (void data, textStatus, jqXHR);
            }, 
            // return ajax fail when something went wrong.
            function (jqXHR, status, error) {
                var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, url);
                PortalContainer.progressHide();
                PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                return ($.Deferred().reject(jqXHR, status, error));
            });
        }
        PortalContainer.get = get;
        /**
         * @deprecated Obsolete Use Request.getByDashboardWidgetId Instead
         */
        function getPartial(dashboardWidgetId, getUrl, options, setStatus, onCompleteFunc, enableModalProgress) {
            var _data = options || {};
            if (setStatus) {
                PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.busy);
            }
            try {
                if (enableModalProgress) {
                    PortalContainer.progressShow();
                }
                // Ensure that the required data has been set.
                if (dashboardWidgetId) {
                    _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                }
                else {
                    dashboardWidgetId = GSS.common.getParameterByName(PortalContainer.requestFields.dashboardWidgetId);
                    _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                }
                // Invoke the get.
                $.ajax({ type: 'GET', url: getUrl, data: _data, cache: false })
                    .always(function (data) {
                    if (onCompleteFunc) {
                        if (typeof (onCompleteFunc) === "function") {
                            onCompleteFunc(data);
                        }
                        else if (typeof (onCompleteFunc) === "string") {
                            GSS.common.getFunction(onCompleteFunc)(data);
                        }
                    }
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.available);
                    }
                })
                    .fail(function (jqXHR, status, error) {
                    var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'getPartial');
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.error);
                    }
                    PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                });
            }
            catch (ex) {
                var _errorData = PortalContainer.setErrorData(ex.message, PortalContainer.fileName, 'getPartial');
                if (setStatus) {
                    PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.error);
                }
                PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
            }
        }
        PortalContainer.getPartial = getPartial;
        /**
         * @description Function that wraps widget initialization.
         * @param {any} initFunction The initialize function of the widget.
         * @param {any} dashboardWidgetId The id of the dashboard widget id.
         * @param {any} settings The options related to the initialization function.
         */
        function invokeWidgetInit(initFunction, dashboardWidgetId, settings) {
            setTimeout(function () {
                var _func = null;
                try {
                    _func = GSS.common.getFunction(initFunction);
                    if (_func == null || typeof _func !== 'function') {
                        throw 'Initialization function not defined';
                    }
                }
                catch (ex) {
                    var _errorData = PortalContainer.setErrorData(ex.message, PortalContainer.fileName, 'invokeWidgetInit');
                    PortalContainer.onFail(dashboardWidgetId, PortalContainer.errorType.init, _errorData);
                    return false;
                }
                var _settingObj = null;
                if (settings) {
                    if (typeof (settings) === 'string') {
                        _settingObj = JSON.parse(settings);
                    }
                    else if (typeof (settings) === 'object') {
                        _settingObj = settings;
                    }
                }
                _func.apply(null, [dashboardWidgetId, _settingObj]);
            }, 1);
        }
        PortalContainer.invokeWidgetInit = invokeWidgetInit;
        /**
         * @description Show the content in a modal.
         * @param {any} modalContent The content in the modal.
         * @param {boolean} disableDeadZoneClick The value indicates whether the modal is static or not.
         * @param {string} sectionIdToHide Hide a section inside the modal content.
         * @param {any} onCompleteFunc The function will be called after the tile is initialized.
         */
        function modalShowContent(modalContent, disableDeadZoneClick, sectionIdToHide, onCompleteFunc) {
            if (disableDeadZoneClick === void 0) { disableDeadZoneClick = false; }
            var _updateContent = true;
            var _modalContainer = $('#' + PortalContainer.modalValues.container);
            _modalContainer.empty();
            if (_modalContainer.length == 0) {
                _updateContent = false;
                _modalContainer = $(document.createElement('div'))
                    .attr('id', PortalContainer.modalValues.container)
                    .attr('class', 'modal fade in')
                    .attr('tabindex', -1)
                    .attr('role', 'dialog')
                    .attr('aria-labelledby', PortalContainer.modalValues.container);
            }
            if (disableDeadZoneClick) {
                $(_modalContainer).attr({ 'data-backdrop': 'static' });
            }
            $(_modalContainer).empty().append(modalContent);
            $(_modalContainer).modal('show');
            // Add the on complete function if it exists
            if (onCompleteFunc) {
                if (typeof (onCompleteFunc) === "function") {
                    if (_updateContent) {
                        onCompleteFunc();
                    }
                    else {
                        $(_modalContainer).on('shown.bs.modal', function () { onCompleteFunc(); });
                    }
                }
                else if (typeof (onCompleteFunc) === "string") {
                    if (_updateContent) {
                        GSS.common.getFunction(onCompleteFunc)();
                    }
                    else {
                        $(_modalContainer).on('shown.bs.modal', function () { GSS.common.getFunction(onCompleteFunc)(); });
                    }
                }
            }
            if (GSS.common.isNotNullOrEmpty(sectionIdToHide)) {
                $(_modalContainer).children("div").find(sectionIdToHide).hide();
            }
            // Add the event that clears the modal cache
            $(_modalContainer).on('hidden.bs.modal', function () {
                if (GSS.common.isNotNullOrEmpty(sectionIdToHide)) {
                    $(this).children("div").find(sectionIdToHide).toggle();
                }
                $(this).removeData('bs.modal');
                $(this).empty();
                $(this).remove();
            });
            return true;
        }
        PortalContainer.modalShowContent = modalShowContent;
        /**
         * @description Show the result of the request in a modal window.
         * @param {any} el The element to get the closest dashboard widget id for.
         * @param {boolean} e The event to invoke this function.
         * @param {boolean} isStatic The value indicates whether the modal is static or not.
         * @param {string} getViewAction The url of the request.
         * @param {any} onCompleteFunc The function will be called after the response is received.
         * @param {any} ajaxData The data will be sent in the request.
         * @param {string} callType The Http request method.
         * @param {boolean} cacheEnabled Enable the cache or not.
         */
        function modalShow(el, e, isStatic, getViewAction, onCompleteFunc, ajaxData, callType, cacheEnabled) {
            if (callType === void 0) { callType = 'GET'; }
            if (cacheEnabled === void 0) { cacheEnabled = false; }
            var _contentType = null;
            var _updateContent = true;
            var _modalContainer = $('#' + PortalContainer.modalValues.container);
            if (_modalContainer.length == 0) {
                _updateContent = false;
                _modalContainer = $(document.createElement('div'))
                    .attr('id', PortalContainer.modalValues.container)
                    .attr('class', 'modal fade in')
                    .attr('tabindex', -1)
                    .attr('role', 'dialog')
                    .attr('aria-labelledby', PortalContainer.modalValues.container)
                    .attr('aria-label', PortalContainer.modalValues.container);
            }
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            var _data = ajaxData || {};
            _data = PortalContainer.setRequiredData(_dashboardWidgetId, _data);
            if (typeof (_data) === "object") {
                if (callType === 'POST') {
                    _data = JSON.stringify(_data);
                    _contentType = 'application/json; charset=utf-8';
                }
                else {
                    _data = jQuery.param(_data, true);
                }
            }
            var _requestOptions = {
                type: callType,
                url: getViewAction,
                data: _data,
                cache: cacheEnabled
            };
            if (_contentType) {
                _requestOptions['contentType'] = _contentType;
            }
            $.ajax(_requestOptions)
                .done(function (data, textStatus, jqXHR) {
                if (isStatic) {
                    $(_modalContainer).data('backdrop', 'static');
                }
                else {
                    $(_modalContainer).removeData('backdrop');
                }
                // Empty the modal container and replace with the view data
                $(_modalContainer).empty().append(data);
                if (!_updateContent) {
                    $(_modalContainer).modal('show');
                }
            })
                .always(function () {
                if (onCompleteFunc) {
                    if (typeof (onCompleteFunc) === "function") {
                        if (_updateContent) {
                            onCompleteFunc();
                        }
                        else {
                            $(_modalContainer).on('shown.bs.modal', function () { onCompleteFunc(); });
                        }
                    }
                    else if (typeof (onCompleteFunc) === "string") {
                        if (_updateContent) {
                            GSS.common.getFunction(onCompleteFunc)();
                        }
                        else {
                            $(_modalContainer).on('shown.bs.modal', function () { GSS.common.getFunction(onCompleteFunc)(); });
                        }
                    }
                }
            })
                .fail(function (jqXHR, status, error) {
                var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'modalShow');
                PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
            });
            // Add the event that clears the modal cache
            $(_modalContainer).on('hidden.bs.modal', function () {
                $(this).removeData('bs.modal');
                $(this).empty();
                $(this).remove();
            });
            return true;
        }
        PortalContainer.modalShow = modalShow;
        /**
         * @description Hide the modal window.
         * @param {any} clear Clear the modal content.
         */
        function modalHide(clear) {
            var _modalContainerSelector = '#' + PortalContainer.modalValues.container;
            var _modalContainer = $(_modalContainerSelector);
            if (clear) {
                _modalContainer.empty();
            }
            if (_modalContainer.length > 0) {
                $(_modalContainerSelector).modal('hide');
            }
            return true;
        }
        PortalContainer.modalHide = modalHide;
        /**
         * @description Sends an error notification about a widget error.
         * @param {any} dashboardWidgetId The dashboard widget that errored
         * @param {any} subject The notification subject.
         * @param {any} errorData The error details.
         */
        function notifyWidgetError(dashboardWidgetId, subject, errorData) {
            // Clear the content before POSTing data
            errorData['content'] = '';
            setTimeout(function () {
                var _data = errorData;
                GSS.common.extendValue(_data, GSS.widget.widgetErrorSettings.subjectParamName, subject);
                if (!(_data.error == "timeout" && _data['url'] == '../_Portal/Cart')) {
                    $.ajax({ type: 'POST', url: GSS.widget.widgetErrorSettings.url, data: jQuery.param(_data), cache: false });
                }
            }, 1);
        }
        PortalContainer.notifyWidgetError = notifyWidgetError;
        /**
         * @deprecated Obsolete Need to refactor to use Request.postByEvent
         */
        function post(el, url, data) {
            PortalContainer.progressShow();
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            var _data = PortalContainer.setRequiredData(_dashboardWidgetId, data);
            //Create an ajax call to controller and return request as Promise object
            var request = GSS.common.request(url).post(_data);
            // process Promise object
            return request.then(
            // return ajax success
            function (data, textStatus, jqXHR) {
                PortalContainer.progressHide();
                return (void data, textStatus, jqXHR);
            }, 
            // return ajax fail when something went wrong.
            function (jqXHR, status, error) {
                var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'portalContainer.post => ' + url);
                PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                return ($.Deferred().reject(jqXHR, status, error));
            });
        }
        PortalContainer.post = post;
        /**
         * @description Pefroms an ajax post to the specified url using the closest dashboard widget id from the specified element.
         * @param {any} el The element to get the closest dashboard widget id for.
         * @param {any} e The event that triggered the post by element function call.
         * @param {any} url The url to post to.
         * @param {any} data The data to post.
         * @returns {JQueryXHR} A jQuery ajax result.  This is done to create hooks for the complete, success, error methods.
         */
        function postByElement(el, e, url, data) {
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            return PortalContainer.postByDashboardWidgetId(_dashboardWidgetId, url, data);
        }
        PortalContainer.postByElement = postByElement;
        /**
         * @description Pefroms an ajax post to the specified url using the closest dashboard widget id from the specified element.
         * @param {any} dashboardWidgetId The id of the dashboard widget to post for.
         * @param {any} url The url to post to.
         * @param {any} data The data to post.
         * @returns {JQueryXHR} A jQuery ajax result.  This is done to create hooks for the complete, success, error methods.
         */
        function postByDashboardWidgetId(dashboardWidgetId, url, data) {
            var _data = data;
            _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
            return $.ajax({ type: 'POST', url: url, data: jQuery.param(_data), cache: false });
        }
        PortalContainer.postByDashboardWidgetId = postByDashboardWidgetId;
        /**
         * @deprecated Obsolete
         */
        function postForm(el, onComplete) {
            /// <summary>Sets up the javascript event binding for the widget 2 object.</summary>
            /// <param name="el">The element that contains the closes form element to post.</param>
            /// <param name="e">The event that triggers the post.</param>
            /// <remakrs>This is setup as an old fashioned event instead of using jQuery binding to avoid calling "on" functions for every DOM change.</remarks>
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            var _form = $(el).closest('form').first();
            var _data = _form.serialize();
            // Register callback functions
            var callbacks = $.Callbacks("once");
            callbacks.add(onComplete);
            _data = PortalContainer.setRequiredData(_dashboardWidgetId, _data);
            //Create an ajax call to controller
            var request = GSS.common.request(_form.attr('action')).post(_data);
            // New client is successfully createad
            request.done(function (data, textStatus, jqXHR) {
                // Re-render the incoming contents.
                if (data && data.content) {
                    PortalContainer.setContent(_dashboardWidgetId, data.content);
                }
                // Fire callback function
                callbacks.fire(data, _dashboardWidgetId);
            });
            // Something went wrong. Request fails.
            request.fail(function (jqXHR, textStatus, error) {
                var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'postForm');
                PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
            });
            return true;
        }
        PortalContainer.postForm = postForm;
        /**
         * @deprecated Obsolete
         */
        function submitForm(el, dataType) {
            var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
            var _form = $(el).closest('form').first();
            var _data = _form.serialize();
            _data = PortalContainer.setRequiredData(_dashboardWidgetId, _data);
            //Create an ajax call to controller and return request as Promise object
            var request = GSS.common.request(_form.attr('action'), dataType, false).post(_data);
            // process Promise object
            return request.then(
            // return ajax success
            function (data, textStatus, jqXHR) {
                // Re-render the incoming contents.
                if (data && data.content) {
                    PortalContainer.setContent(_dashboardWidgetId, data.content);
                }
                return (void data, textStatus, jqXHR);
            }, 
            // return ajax fail when something went wrong.
            function (jqXHR, status, error) {
                var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'postForm');
                PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                return ($.Deferred().reject(jqXHR, status, error));
            });
        }
        PortalContainer.submitForm = submitForm;
        var _progressModal = (function () {
            var _progress;
            return function (options) {
                if (!GSS.common.isNotNullOrEmpty(_progress)) {
                    _progress = new Progress('body', options);
                }
                return _progress;
            };
        })();
        /**
         * @description Show the progress bar.
         * @param {any} message The message shows in the progress bar.
         * @param {any} delay The time of delay.
         * @param {any} useMetaData Use meta data.
         * @returns {boolean} Return true if the progress bar shows correctly.
         */
        function progressShow(message, delay, useMetaData) {
            if (useMetaData === void 0) { useMetaData = true; }
            _progressModal({ message: message, delay: delay, useMetaData: useMetaData }).open();
            return true;
        }
        PortalContainer.progressShow = progressShow;
        /**
         * @description Hide the progress bar.
         * @returns {boolean} Return true if the progress bar hides correctly.
         */
        function progressHide() {
            _progressModal().close();
            return true;
        }
        PortalContainer.progressHide = progressHide;
        /**
         * @description Show the progress bar and auto hide it after the response is received.
         * @param {any} message The message shows in the progress bar.
         * @param {any} delay The time of delay.
         * @param {any} useMetaData Use meta data.
         * @returns {JQuery} Return JQuery object.
         */
        function progressLoading(message, delay, useMetaData) {
            if (useMetaData === void 0) { useMetaData = true; }
            $('body').gssAjaxProgress({ message: message, delay: delay, useMetaData: useMetaData });
        }
        PortalContainer.progressLoading = progressLoading;
        /**
         * @description Takes the incoming message and calls all of the consume message functions.
         * @param {any} message The message to relay to all of the consume message functions.
         */
        function queueMsg(message) {
            // Pass the message to the portal container.
            setTimeout(PortalContainer.consumeMessage, 1, message);
            // If the collection of subscribers is defined, pass along the message to each subscriber.
            if (PortalContainer.subscriptions) {
                $(PortalContainer.subscriptions).each(function () {
                    // Call each message handler function in a setTimeout call.  This will ensure that each method call is processed "asynchronously".
                    setTimeout(this, 1, message);
                });
            }
        }
        PortalContainer.queueMsg = queueMsg;
        /**
         * @description Redirects to the full application view for the specified widget using the data as a query string.
         * @param {any} dashboardWidgetId The unique widget instance identifier
         * @param {any} data The optional data to append to the url.
         */
        function redirectToFullApp(dashboardWidgetId, data) {
            window.location.href = PortalContainer.getFullAppUrl(dashboardWidgetId, data);
        }
        PortalContainer.redirectToFullApp = redirectToFullApp;
        /**
        * @description Redirects to the survey dashboard view using the data as a query string.
        * @param {any} dashboardWidgetId The unique widget instance identifier
        * @param {any} data The optional data to append to the url.
        */
        function redirectToSurveyDashboard(dashboardWidgetId, data) {
            var _data = data || '';
            var baseUrl = '../_Portal/SurveyDashboardAsync?';
            _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
            if (typeof (_data) === 'object') {
                _data = GSS.common.encodeAndParameterize(_data);
            }
            window.location.href = baseUrl + _data;
        }
        PortalContainer.redirectToSurveyDashboard = redirectToSurveyDashboard;
        /**
       * @description Redirects to the full application view for the specified widget using the data as a query string.
       * @param {any} dashboardWidgetId The unique widget instance identifier
       * @param {any} data The optional data to append to the url.
       */
        function redirectToApp() {
            var _dashboardWidgetId = $(this).closest('[data-gss-dashboard-widget-id]').attr('data-gss-dashboard-widget-id');
            var data;
            window.location.href = PortalContainer.getFullAppUrl(_dashboardWidgetId, data);
        }
        PortalContainer.redirectToApp = redirectToApp;
        /**
        * @description Extends user current sesion
        */
        function extendSession() {
            var _doNothing = function () {
                return false;
            };
            PortalContainer.refreshAccessToken(_doNothing);
        }
        PortalContainer.extendSession = extendSession;
        /**
         * @description Refresh the access token.
         * @param {any} onSuccess The method will be called after the token is refreshed
         */
        function refreshAccessToken(onSuccess) {
            var _data = {};
            var dashboardWidgetId = PortalContainer.getDashboardWidgetId();
            if (dashboardWidgetId) {
                _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
            }
            else {
                _data = GSS.pc.Request.setRequiredData(null, _data);
            }
            $.ajax({ type: 'POST', url: '../_Portal/RefreshAccessToken', data: jQuery.param(_data) })
                .done(function (data, status, jqXHR) {
                if (onSuccess) {
                    onSuccess();
                }
            });
        }
        PortalContainer.refreshAccessToken = refreshAccessToken;
        /**
         * @description Handles the logic of resizing a specific widget.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} height The new height of the widget.
         * @param {any} width The new width of the widget.
         */
        function resizeTile(dashboardWidgetId, height, width) {
            /// <remarks>This is not being used currently, as the dynamnic resizing was taken out.</remarks>
            // Set the height and width values on the current widget container.
            var _widgetContainer = GSS.widget.getWidgetContainer(dashboardWidgetId);
            _widgetContainer.attr(GSS.widget.attributeNames.dashboardWidgetHeight, height);
            _widgetContainer.attr(GSS.widget.attributeNames.dashboardWidgetWidth, width);
            // Send the message to notify the widget that it needs to be resized.
            var _resizePayload = {};
            _resizePayload[PortalContainer.requestFields.height] = height;
            _resizePayload[PortalContainer.requestFields.width] = width;
            var _message = PortalContainer.createMessage(dashboardWidgetId, PortalContainer.actionNames.resize, _resizePayload);
            PortalContainer.queueMsg(_message);
        }
        PortalContainer.resizeTile = resizeTile;
        /**
         * @description Sets the content based on the specified unique widget identifier.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} content The content used to replace the main widget content.
         */
        function setContent(dashboardWidgetId, content) {
            if (!dashboardWidgetId) {
                dashboardWidgetId = PortalContainer.getDashboardWidgetId();
            }
            var _contentElement = GSS.widget.getWidgetContentElement(dashboardWidgetId);
            if (_contentElement) {
                _contentElement.html(content);
            }
        }
        PortalContainer.setContent = setContent;
        /**
         * @description Sets up the widget application based on the data object.
         * @param {any} data The standard widget response data.
         */
        function setApp(data, dashboardWidgetId) {
            if (!data) {
                return true;
            }
            var _widgetDashboardId = dashboardWidgetId || data[PortalContainer.responseFields.dashboardWidgetId];
            if (_widgetDashboardId) {
                // Set the widget content.
                var _content = data[PortalContainer.responseFields.content] || data;
                if (_content) {
                    PortalContainer.setContent(_widgetDashboardId, _content);
                }
                // Set the widget title.
                var _title = data[PortalContainer.responseFields.title];
                if (_title) {
                    PortalContainer.setTitle(_widgetDashboardId, _title);
                }
                // Set the navigation items.
                var _navItems = data[PortalContainer.responseFields.navigationItems];
                if (_navItems) {
                    // Navigation item support has been removed for now since it is not being used.
                }
                // Queue up any messages as needed.
                var _msgs = data[PortalContainer.responseFields.messages];
                if (_msgs) {
                    $(_msgs).each(function () { PortalContainer.queueMsg(this); });
                }
            }
        }
        PortalContainer.setApp = setApp;
        /**
         * @description Sets the error data.
         * @param {any} jqXHR The jqXHR.
         * @param {any} jsFile The javascript file name.
         * @param {any} functionCalled The function has the error.
         * @returns{object} The object contains the error details.
         */
        function setErrorData(jqXHR, jsFile, functionCalled, url) {
            if (url === void 0) { url = ""; }
            var data = {};
            data['error'] = jqXHR ? jqXHR.statusText : 'Error';
            data['content'] = jqXHR ? jqXHR.responseText : 'Error';
            data['file'] = jsFile;
            data['method'] = functionCalled;
            data['url'] = url;
            return data;
        }
        PortalContainer.setErrorData = setErrorData;
        /**
         * @description Extends the incoing data object with the required request data.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} data The data object to extend
         * @returns{object} The object contains the required data.
         */
        function setRequiredData(dashboardWidgetId, data) {
            if (!dashboardWidgetId) {
                dashboardWidgetId = GSS.common.getAttributeValue(GSS.widget.attributeNames.dashboardWidgetId, null);
            }
            var _clientId = GSS.common.getAttributeValue(GSS.widget.attributeNames.clientId, null);
            if (_clientId) {
                data = GSS.common.extendValue(data, PortalContainer.requestFields.clientId, _clientId);
            }
            data = GSS.common.extendValue(data, PortalContainer.requestFields.dashboardWidgetId, dashboardWidgetId);
            data = GSS.common.addAntiForgeryToken(data);
            return data;
        }
        PortalContainer.setRequiredData = setRequiredData;
        /**
         * @description Sets the widget entire tile markup based on the incoming data.
         * @param {any} data The standard widget response data.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         */
        function setTile(data, dashboardWidgetId) {
            /// <summary>Sets the widget entire tile markup based on the incoming data.</summary>
            /// <param name="data">The standard widget response data.</param>
            if (!data) {
                return true;
            }
            var _widgetDashboardId = dashboardWidgetId || data[PortalContainer.responseFields.dashboardWidgetId];
            if (_widgetDashboardId) {
                // Set the widget content.
                var _content = data[PortalContainer.responseFields.content];
                if (_content) {
                    PortalContainer.setContent(_widgetDashboardId, _content);
                }
                // Queue up any messages as needed.
                var _msgs = data[PortalContainer.responseFields.messages];
                if (_msgs) {
                    $(_msgs).each(function () { PortalContainer.queueMsg(this); });
                }
            }
        }
        PortalContainer.setTile = setTile;
        /**
         * @description Sets the title based on the specified unique widget identifier.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} title The title value.
         */
        function setTitle(dashboardWidgetId, title) {
            if (!dashboardWidgetId) {
                dashboardWidgetId = PortalContainer.getDashboardWidgetId();
            }
            var _titleElement = GSS.widget.getWidgetTitleElement(dashboardWidgetId);
            if (_titleElement) {
                _titleElement.html(title);
            }
        }
        PortalContainer.setTitle = setTitle;
        /**
         * @description Sets the content into the widget container.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} content The content will be put in the widget container.
         */
        function setWidgetContainerContent(dashboardWidgetId, content) {
            if (!dashboardWidgetId) {
                dashboardWidgetId = PortalContainer.getDashboardWidgetId();
            }
            var _container = GSS.widget.getWidgetContainer(dashboardWidgetId);
            if (!_container) {
                return false;
            }
            $(_container).html(content);
        }
        PortalContainer.setWidgetContainerContent = setWidgetContainerContent;
        /**
         * @description Updates the status for the widget.
         * @param {any} dashboardWidgetId The identifier for the widget to update the status for.
         * @param {any} status The new status for the widget.
         * @param {any} uiMessage (Optional) message to show in the widget.
         */
        function setWidgetStatus(dashboardWidgetId, status, uiMessage) {
            var _container = GSS.widget.getWidgetContainer(dashboardWidgetId);
            if (!_container) {
                return false;
            }
            var _prevStatus = $(_container).attr(GSS.widget.attributeNames.widgetStatus);
            var _newStatus = status.toLowerCase();
            var _msg = uiMessage;
            if (_msg || _newStatus === "error") {
                // If we don't have a message it's an error, use default error message.
                _msg = _msg || GSS.portal.errorContent.content;
                var __content = $('<p class="gss-tile-message">' + _msg + "</p>");
                PortalContainer.setContent(dashboardWidgetId, __content);
            }
            // If the status has changed, update the status and then apply the style changes.
            if (_prevStatus != status) {
                $(_container).attr(GSS.widget.attributeNames.widgetStatus, _newStatus)
                    .removeClass('widget_status_' + _prevStatus)
                    .addClass('widget_status_' + _newStatus);
            }
        }
        PortalContainer.setWidgetStatus = setWidgetStatus;
        /**
         * @description Adds the function to the list of functions that get alerted when a message is queued for the communication bus.
         * @param {any} consumeMsgFunc The javascript function that is used to consume the messages in the event bus.
         */
        function subscribe(consumeMsgFunc) {
            PortalContainer.subscriptions[PortalContainer.subscriptions.length] = consumeMsgFunc;
        }
        PortalContainer.subscribe = subscribe;
        /**
         * @description Handles a failed widget initialization.
         * @param {any} dashboardWidgetId The unique widget instance identifier.
         * @param {any} data The data object for the failed widget initialization request.
         * @param {any} ex The exception value.
         */
        function onWidgetInitializeFail(dashboardWidgetId, errorData) {
            PortalContainer.setWidgetStatus(dashboardWidgetId, PortalContainer.widgetStatus.error);
            PortalContainer.notifyWidgetError(dashboardWidgetId, 'Widget failed to load', errorData);
        }
        PortalContainer.onWidgetInitializeFail = onWidgetInitializeFail;
        /**
         * @description Function called when an error occurs.
         * @param {any} data The data to display on error.
         */
        function onFail(dashboardWidgetId, errorType, errorData) {
            errorData = PortalContainer.setRequiredData(dashboardWidgetId, errorData);
            errorData["errorType"] = errorType;
            this.modalHide();
            switch (errorType) {
                case this.errorType.init:
                    PortalContainer.onWidgetInitializeFail(dashboardWidgetId, errorData);
                    break;
                case this.errorType.generic:
                    this.setWidgetContainerContent(dashboardWidgetId, errorData["content"]);
                    PortalContainer.notifyWidgetError(dashboardWidgetId, 'An error occurred', errorData);
                    break;
                case this.errorType.undefined:
                    PortalContainer.notifyWidgetError(dashboardWidgetId, 'Unknown error', errorData);
                    break;
            }
        }
        PortalContainer.onFail = onFail;
        /**
         * @description Send a request to set user widget setting.
         * @param {any} dashboardWidgetId The dashboard widget to set the setting for.
         * @param {any} value The value of the setting.
         */
        function setUserWidgetSettings(dashboardWidgetId, value) {
            var _data = {};
            _data['value'] = value;
            return PortalContainer.postByDashboardWidgetId(dashboardWidgetId, PortalContainer.url.setUserWidgetSettings, _data);
        }
        PortalContainer.setUserWidgetSettings = setUserWidgetSettings;
        /**
         * @description Provides functionality for working with server requests.
         */
        var Request;
        (function (Request) {
            /**
             * @description Generates an HTTP GET request to get the dashboard widget.
             * @param {string} dashboardWidgetId a dashboard widget id.
             * @param {string} url The url of the request.
             * @param {Object} options a json object data for the request.
             * @param {string} dataType return data type of the request.
             * @param {boolean} setStatus a flag to set widget status.
             * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
             * @param {boolean} enableCache Enable the cache or not.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function getByDashboardWidgetId(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, enableCache) {
                return Core.get(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, enableCache);
            }
            Request.getByDashboardWidgetId = getByDashboardWidgetId;
            /**
            * @description Generates an HTTP GET request to get the dashboard widget with History capture ready.
            * @param {string} dashboardWidgetId a dashboard widget id.
            * @param {string} url The url of the request.
            * @param {Object} options a json object data for the request.
            * @param {string} dataType return data type of the request.
            * @param {boolean} setStatus a flag to set widget status.
            * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
            * @param {string} attrValue a data attribute value to render the partial view.
            * @param {string} attrProperty a data attribute property to render the partial view.
            * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
            * @return {JQueryPromise<any>}  A Promise.
            */
            function getByDashboardWidgetIdWithHistoryAjax(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, attrValue, attrProperty, parent) {
                if (parent === void 0) { parent = true; }
                return Core.getWithHistoryAjax(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, attrValue, attrProperty, parent);
            }
            Request.getByDashboardWidgetIdWithHistoryAjax = getByDashboardWidgetIdWithHistoryAjax;
            /**
           * @description Generates an HTTP GET request to get the dashboard widget with History capture ready.
           * @param {string} dashboardWidgetId a dashboard widget id.
           * @param {string} url The url of the request.
           * @param {Object} options a json object data for the request.
           * @param {string} dataType return data type of the request.
           * @param {boolean} setStatus a flag to set widget status.
           * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
           * @param {string} callback a full qualified function's name and its path.
           * @param {Object} callbackData a json object data for callback function.
           * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
           * @return {JQueryPromise<any>}  A Promise.
           */
            function getByDashboardWidgetIdWithHistoryCallback(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, callback, callbackData, parent) {
                if (parent === void 0) { parent = true; }
                return Core.getWithHistoryCallback(dashboardWidgetId, url, options, dataType, setStatus, enableModalProgress, callback, callbackData, parent);
            }
            Request.getByDashboardWidgetIdWithHistoryCallback = getByDashboardWidgetIdWithHistoryCallback;
            /**
             * @description Generates an HTTP GET request.
             * @param e The event.
             * @param url The url of the request.
             * @param data The additional data for the request.
             * @param dataType The data type of the request.
             * @param enableModalProgress Show the progress bar or not when sending the request.
             * @param enableCache Enable the cache or not.
             * @param timeout The optional request timeout in milliseconds.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function getByEvent(e, url, data, dataType, enableModalProgress, enableCache, timeout) {
                return Core.get(e, url, data, dataType, false, enableModalProgress, enableCache, timeout);
            }
            Request.getByEvent = getByEvent;
            /**
            * @description Generates an HTTP GET request with History capture ready.
            * @param {JQueryEventObject} e The event.
            * @param {string} url The url of the request.
            * @param {Object} data a json object data for the request.
            * @param {string} dataType return data type of the request.
            * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
            * @param {string} attrValue a data attribute value to render the partial view.
            * @param {string} attrProperty a data attribute property to render the partial view.
            * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
            * @return {JQueryPromise<any>}  A Promise.
            */
            function getByEventWithHistoryAjax(e, url, data, dataType, enableModalProgress, attrValue, attrProperty, parent) {
                if (parent === void 0) { parent = true; }
                return Core.getWithHistoryAjax(e, url, data, dataType, false, enableModalProgress, attrValue, attrProperty, parent);
            }
            Request.getByEventWithHistoryAjax = getByEventWithHistoryAjax;
            /**
            * @description Generates an HTTP GET request with History capture ready.
            * @param {JQueryEventObject} e The event.
            * @param {string} url The url of the request.
            * @param {Object} data a json object data for the request.
            * @param {string} dataType return data type of the request.
            * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
            * @param {string} callback a full qualified function's name and its path.
            * @param {Object} callbackData a json object data for callback function.
            * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
            * @return {JQueryPromise<any>}  A Promise.
            */
            function getByEventWithHistoryCallback(e, url, data, dataType, enableModalProgress, callback, callbackData, parent) {
                if (parent === void 0) { parent = true; }
                return Core.getWithHistoryCallback(e, url, data, dataType, false, enableModalProgress, callback, callbackData, parent);
            }
            Request.getByEventWithHistoryCallback = getByEventWithHistoryCallback;
            /**
             * @description Generates an HTTP POST request.
             * @param {JQueryEventObject} e The event.
             * @param {string} url The url of the request.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
             * @param {boolean} enableCache Enable the cache or not.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function postByEvent(e, url, data, dataType, enableModalProgress, enableCache, timeout, contentType, overrideComponentName) {
                return Core.post(e, url, data, dataType, enableModalProgress, enableCache, timeout, contentType, overrideComponentName);
            }
            Request.postByEvent = postByEvent;
        })(Request = PortalContainer.Request || (PortalContainer.Request = {}));
        /**
         * @description Provides functionality for the core functions.
         */
        var Core;
        (function (Core) {
            /**
             * @description Gets widget info by dashboard widget id.
             * @param {string} dashboardWidgetId The unique widget instance identifier.
             * @param {any} data The data will be extended with widget info.
             * @returns {object} The data extended with widget info.
             */
            function getWidgetInfoByDashboardWidgetId(dashboardWidgetId, data) {
                var _obj = { DashboardWidgetId: '', Data: {} };
                var _data = data || {};
                if (dashboardWidgetId) {
                    _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                }
                else {
                    dashboardWidgetId = GSS.common.getParameterByName(PortalContainer.requestFields.dashboardWidgetId);
                    _data = PortalContainer.setRequiredData(dashboardWidgetId, _data);
                }
                _obj.DashboardWidgetId = dashboardWidgetId;
                _obj.Data = _data;
                return _obj;
            }
            Core.getWidgetInfoByDashboardWidgetId = getWidgetInfoByDashboardWidgetId;
            /**
             * @description Gets widget info by event.
             * @param {JQueryEventObject} e The jQuery event object.
             * @param {any} data The data will be extended with widget info.
             * @returns {object} The data extended with widget info.
             */
            function getWidgetInfoByEvent(e, data) {
                var _obj = { DashboardWidgetId: '', Data: {} };
                var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(e);
                var _data = PortalContainer.setRequiredData(_dashboardWidgetId, data);
                _obj.DashboardWidgetId = _dashboardWidgetId;
                _obj.Data = _data;
                return _obj;
            }
            Core.getWidgetInfoByEvent = getWidgetInfoByEvent;
            /**
             * @description Generates an HTTP GET request.
             * @param key The key.
             * @param url The url of the request.
             * @param options The additional data for the request.
             * @param dataType The data type of the request.
             * @param setStatus Set the widget status or not.
             * @param enableModalProgress Show the progress bar or not when sending the request.
             * @param enableCache Enable the cache or not.
             * @param timeout The optional request timeout in milliseconds.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function get(key, url, options, dataType, setStatus, enableModalProgress, enableCache, timeout) {
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                enableModalProgress = enableModalProgress || false;
                setStatus = setStatus || false;
                enableCache = enableCache || false;
                var _useDashboardWidgetId;
                var _widgetInfo;
                if (typeof key === 'string') {
                    _useDashboardWidgetId = true;
                }
                else {
                    _useDashboardWidgetId = false;
                }
                if (_useDashboardWidgetId) {
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.busy);
                    }
                }
                if (enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                if (_useDashboardWidgetId) {
                    _widgetInfo = Core.getWidgetInfoByDashboardWidgetId(key, options);
                }
                else {
                    _widgetInfo = Core.getWidgetInfoByEvent(key, options);
                }
                // Invoke the get.
                var _request = GSS.common.request(url, dataType, enableCache, timeout).get(_widgetInfo.Data);
                return _request.then(
                // return ajax as success when request successful processes.
                function (data, textStatus, jqXHR) {
                    // PortalContainer.progressHide();
                    if (_useDashboardWidgetId) {
                        if (setStatus) {
                            PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.available);
                        }
                    }
                    return (void data, textStatus, jqXHR);
                }, 
                // return ajax as fail when request got error while processing.
                function (jqXHR, status, error) {
                    var _errorData;
                    if (_useDashboardWidgetId) {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByDashboardWidgetId', url);
                    }
                    else {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByEvent', url);
                    }
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.error);
                    }
                    PortalContainer.onFail(_widgetInfo.DashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Core.get = get;
            /**
             * @description Generates an HTTP GET request with History capture ready.
             * @param {any} key The key.
             * @param {string} url The url of the request.
             * @param {any} options The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @param {boolean} setStatus Set the widget status or not.
             * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
             * @param {string} attrValue a data attribute value to render the partial view.
             * @param {string} attrProperty a data attribute property to render the partial view.
             * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function getWithHistoryAjax(key, url, options, dataType, setStatus, enableModalProgress, attrValue, attrProperty, parent) {
                if (parent === void 0) { parent = true; }
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                if (setStatus !== undefined) {
                    if (typeof setStatus !== 'boolean') {
                        void 0;
                    }
                }
                if (enableModalProgress !== undefined) {
                    if (typeof enableModalProgress !== 'boolean') {
                        void 0;
                    }
                }
                if (attrValue !== undefined) {
                    if (typeof attrValue !== 'string') {
                        void 0;
                    }
                }
                if (attrProperty !== undefined) {
                    if (typeof attrProperty !== 'string') {
                        void 0;
                    }
                }
                if (parent !== undefined) {
                    if (typeof parent !== 'boolean') {
                        void 0;
                    }
                }
                enableModalProgress = enableModalProgress || false;
                setStatus = setStatus || false;
                var _useDashboardWidgetId;
                var _widgetInfo;
                if (typeof key === 'string') {
                    _useDashboardWidgetId = true;
                }
                else {
                    _useDashboardWidgetId = false;
                }
                if (_useDashboardWidgetId) {
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.busy);
                    }
                }
                if (enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                if (_useDashboardWidgetId) {
                    _widgetInfo = Core.getWidgetInfoByDashboardWidgetId(key, options);
                }
                else {
                    _widgetInfo = Core.getWidgetInfoByEvent(key, options);
                }
                // Invoke the get.
                var _request = GSS.common.request(url, dataType, false).get(_widgetInfo.Data);
                // save request to history
                var _historyReq = {
                    id: _widgetInfo.DashboardWidgetId,
                    url: url,
                    data: _widgetInfo.Data,
                    attrPropery: attrProperty,
                    attrValue: attrValue
                };
                GSS.gssHistory.manage(_historyReq, parent);
                return _request.then(
                // return ajax as success when request successful processes.
                function (data, textStatus, jqXHR) {
                    // PortalContainer.progressHide();
                    if (_useDashboardWidgetId) {
                        if (setStatus) {
                            PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.available);
                        }
                    }
                    return (void data, textStatus, jqXHR);
                }, 
                // return ajax as fail when request got error while processing.
                function (jqXHR, status, error) {
                    var _errorData;
                    if (_useDashboardWidgetId) {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByDashboardWidgetId');
                    }
                    else {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByEvent');
                    }
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.error);
                    }
                    PortalContainer.onFail(_widgetInfo.DashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Core.getWithHistoryAjax = getWithHistoryAjax;
            /**
            * @description Generates an HTTP GET request with History capture ready.
            * @param {any} key The key.
            * @param {string} url The url of the request.
            * @param {any} options The additional data for the request.
            * @param {string} dataType The data type of the request.
            * @param {boolean} setStatus Set the widget status or not.
            * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
            * @param {string} callback a full qualified function's name and its path.
            * @param {Object} callbackData a json object data for callback function.
            * @param {boolean} parent set it to true to save history as single state; set it to false to combine two requests in one state then save.
            * @return {JQueryPromise<any>}  A Promise.
            */
            function getWithHistoryCallback(key, url, options, dataType, setStatus, enableModalProgress, callback, callbackData, parent) {
                if (parent === void 0) { parent = true; }
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                if (setStatus !== undefined) {
                    if (typeof setStatus !== 'boolean') {
                        void 0;
                    }
                }
                if (enableModalProgress !== undefined) {
                    if (typeof enableModalProgress !== 'boolean') {
                        void 0;
                    }
                }
                if (callback !== undefined) {
                    if (typeof callback !== 'string') {
                        void 0;
                    }
                }
                if (callbackData !== undefined) {
                    if (typeof callbackData !== 'object') {
                        void 0;
                    }
                }
                if (parent !== undefined) {
                    if (typeof parent !== 'boolean') {
                        void 0;
                    }
                }
                enableModalProgress = enableModalProgress || false;
                setStatus = setStatus || false;
                var _useDashboardWidgetId;
                var _widgetInfo;
                if (typeof key === 'string') {
                    _useDashboardWidgetId = true;
                }
                else {
                    _useDashboardWidgetId = false;
                }
                if (_useDashboardWidgetId) {
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.busy);
                    }
                }
                if (enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                if (_useDashboardWidgetId) {
                    _widgetInfo = Core.getWidgetInfoByDashboardWidgetId(key, options);
                }
                else {
                    _widgetInfo = Core.getWidgetInfoByEvent(key, options);
                }
                // Invoke the get.
                var _request = GSS.common.request(url, dataType, false).get(_widgetInfo.Data);
                // save request to history
                var _historyReq = {
                    url: url,
                    callback: callback,
                    callbackData: callbackData
                };
                GSS.gssHistory.manage(_historyReq, parent);
                return _request.then(
                // return ajax as success when request successful processes.
                function (data, textStatus, jqXHR) {
                    // PortalContainer.progressHide();
                    if (_useDashboardWidgetId) {
                        if (setStatus) {
                            PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.available);
                        }
                    }
                    return (void data, textStatus, jqXHR);
                }, 
                // return ajax as fail when request got error while processing.
                function (jqXHR, status, error) {
                    var _errorData;
                    if (_useDashboardWidgetId) {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByDashboardWidgetId');
                    }
                    else {
                        _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Request.getByEvent');
                    }
                    if (setStatus) {
                        PortalContainer.setWidgetStatus(key, PortalContainer.widgetStatus.error);
                    }
                    PortalContainer.onFail(_widgetInfo.DashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Core.getWithHistoryCallback = getWithHistoryCallback;
            /**
             * @description Generates an HTTP POST request.
             * @param {JQueryEventObject} e The event.
             * @param {string} url The url of the request.
             * @param {any} data The additional data for the request.
             * @param {string} dataType The data type of the request.
             * @param {boolean} enableModalProgress Show the progress bar or not when sending the request.
             * @param {boolean} enableCache Enable the cache or not.
             * @return {JQueryPromise<any>}  A Promise.
             */
            function post(e, url, data, dataType, enableModalProgress, enableCache, timeout, contentType, overrideComponentName) {
                if (url === undefined) {
                    throw new Error("url is invalid.");
                }
                if (dataType === undefined) {
                    throw new Error("Need to specify dataType.");
                }
                enableModalProgress = enableModalProgress || false;
                enableCache = enableCache || false;
                if (enableModalProgress) {
                    PortalContainer.progressLoading();
                }
                var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(e);
                var _data = PortalContainer.setRequiredData(_dashboardWidgetId, data);
                //Create an ajax call to controller and return request as Promise object
                var request = GSS.common.request(url, dataType, enableCache, timeout, contentType, overrideComponentName).post(_data);
                // process Promise object
                return request.then(
                // return ajax success
                function (data, textStatus, jqXHR) {
                    return (void data, textStatus, jqXHR);
                }, 
                // return ajax fail when something went wrong.
                function (jqXHR, status, error) {
                    var _errorData = PortalContainer.setErrorData(jqXHR, PortalContainer.fileName, 'Core.post => ' + url);
                    PortalContainer.onFail(_dashboardWidgetId, PortalContainer.errorType.generic, _errorData);
                    return ($.Deferred().reject(jqXHR, status, error));
                });
            }
            Core.post = post;
        })(Core = PortalContainer.Core || (PortalContainer.Core = {}));
        var SignalR;
        (function (SignalR) {
            var Notifications;
            (function (Notifications) {
                /**
                 * @description This method allows you to observe notification count for the currently logged in user.
                 * This method can be called multiple times by multiple consumers.
                 * Just after executing this method the hub will ask server how many unread notification messages user have and it will inform all
                 * consumers about the number.
                 * @param callback method that should be called when notification hub receives information about new unread count.
                 */
                function startObservingNotifications(callback) {
                    GSS.SignalR.Notifications.getHub()
                        .then(function (hub) {
                        hub.notificationCountEvent.subscribe(callback);
                        hub.server.getNotificationCountPromise();
                    });
                }
                Notifications.startObservingNotifications = startObservingNotifications;
            })(Notifications = SignalR.Notifications || (SignalR.Notifications = {}));
        })(SignalR = PortalContainer.SignalR || (PortalContainer.SignalR = {}));
    })(PortalContainer = GSS.PortalContainer || (GSS.PortalContainer = {}));
    /**
    * @description A history's library use History.js to manipulate browser history.
    */
    var gssHistory;
    (function (gssHistory) {
        /**
        * @description Bind a state change event to a callback function for reloading a page from memory
        */
        function init() {
            // History
            if (window.History.enabled) {
                window.History.Adapter.bind(window, 'statechange', function () {
                    if (_stateChange) {
                        GSS.gssHistory.load();
                    }
                    _stateChange = true;
                    return false;
                });
            }
        }
        gssHistory.init = init;
        /**
        * @description Capture and save a request [GET] to current History's state. Current version only supports a Parent-Child relationship.
        * @param {requestObject} requestData a json object that hold all necessary data for reload the page.
        * @param {boolean} parent set parent flag to TRUE to save current request as parent and FALSE to merge 2 requests together and save them as Parent-Child request.
        * @param {boolean} override set override flag to TRUE to merge 2 requests and save then as a Parent and FALSE merge 2 requests and save them as Parent-Child request. This flag will only affect if parent flag set to False.
        * @param {string} pageName a page name. Most of the time is can be null.
        * @param {boolean} replace set replace flag to true to replace and false to push current state into browser history
        * @param {callBackService} callBackService a json object for implementation how page can be re-render. Most of the time it can be null.
        */
        function manage(requestData, parent, override, pageName, replace, callBackService) {
            if (parent === void 0) { parent = true; }
            if (override === void 0) { override = false; }
            if (replace === void 0) { replace = false; }
            _stateChange = false;
            var _requestData = requestData || {};
            var _callbackService = callBackService || {};
            var _ajaxRequestFunction;
            var _renderContentFunction;
            var _domFunction;
            var _pageName = pageName || '';
            var _replace = replace || false;
            var _parent = parent;
            var _internal = {
                isChild: false,
                url: _requestData.url,
                data: _requestData.data,
                id: _requestData.id,
                requestDoneCallback: _requestData.requestDoneCallback,
                requestDoneData: _requestData.requestDoneData,
                ajaxRequestFunction: _callbackService.ajaxRequestFunction || 'GSS.gssHistory.service.get',
                renderContentFunction: _callbackService.renderContentFunction || 'GSS.gssHistory.service.renderContent',
                domFunction: _callbackService.domFunction || 'GSS.gssHistory.service.restore',
                portal: _requestData.portal || true,
                attrPropery: _requestData.attrPropery || 'data-gss-name',
                attrValue: _requestData.attrValue,
            };
            if (window.History.enabled) {
                // either use custom name or use ajax's url as page name
                if (GSS.common.isNotNullOrEmpty(pageName) && pageName !== null) {
                    _pageName = pageName;
                }
                else {
                    if (GSS.common.isNotNullOrEmpty(requestData.url)) {
                        _pageName = _requestData.url;
                    }
                    else {
                        _pageName = ((new Date).getTime());
                    }
                }
                var _preName = void 0;
                var _isChanged = true;
                // this is child request, do the merge before save history
                if (!parent) {
                    var _newName = service.getPageNameFromUrl('p', window.History.getLocationHref()) + 1;
                    var _state = window.History.getState();
                    var _childData = _state.data.data;
                    if (_requestData.callback === undefined) {
                        void 0;
                        return false;
                    }
                    // If _childData is undefined, instantiate it as an empty object with the required properties. Set properties to empty.
                    if (_childData === undefined) {
                        _childData = new Object();
                        _childData.childCallback = {};
                        _childData.childCallbackData = {};
                        _childData.isChild = false;
                    }
                    _childData.childCallback = _requestData.callback;
                    _childData.childCallbackData = _requestData.callbackData;
                    _childData.isChild = true;
                    if (!override) {
                        window.History.replaceState({ title: gssHistory.callBackType.request, data: _childData || {} }, document.title, service.getNewUrl(_newName));
                    }
                    else {
                        window.History.pushState({ title: gssHistory.callBackType.request, data: _childData || {} }, document.title, service.getNewUrl(_newName));
                    }
                }
                // this is parent request, save history accordingly
                else {
                    // get current state
                    var _state = window.History.getState();
                    if (GSS.common.isNotNullOrEmpty(_state) && GSS.common.isNotNullOrEmpty(_state.data.data)) {
                        _isChanged = service.isChanged(_state.data.data.url, _internal.url);
                    }
                    _internal.callback = _requestData.callback;
                    _internal.callbackData = _requestData.callbackData;
                    _internal.isChild = false;
                    // if the url is changed compare to previous on, push or replace history
                    if (_isChanged) {
                        if (!_replace) {
                            window.History.pushState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.getNewUrl(_pageName.gssHashCode()));
                        }
                        else {
                            window.History.replaceState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.getNewUrl(_pageName.gssHashCode()));
                        }
                    }
                    // if the url is the same as previous one, replace history
                    else {
                        var _newName = service.getPageNameFromUrl('p', window.History.getLocationHref()) + 1;
                        window.History.replaceState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.getNewUrl(_newName));
                    }
                }
            }
            return false;
        }
        gssHistory.manage = manage;
        function manageWithRewriteUrl(requestData, replace, customUrl) {
            if (replace === void 0) { replace = false; }
            if (customUrl === void 0) { customUrl = null; }
            _stateChange = false;
            var _requestData = requestData || {};
            var _callbackService = {};
            var _ajaxRequestFunction;
            var _renderContentFunction;
            var _domFunction;
            var _pageName = '';
            var _replace = replace || false;
            var _parent = parent;
            var _internal = {
                isChild: false,
                url: _requestData.url,
                data: _requestData.data,
                id: _requestData.id,
                requestDoneCallback: _requestData.requestDoneCallback,
                requestDoneData: _requestData.requestDoneData,
                ajaxRequestFunction: _callbackService.ajaxRequestFunction || 'GSS.gssHistory.service.get',
                renderContentFunction: _callbackService.renderContentFunction || 'GSS.gssHistory.service.renderContent',
                domFunction: _callbackService.domFunction || 'GSS.gssHistory.service.restore',
                portal: _requestData.portal || true,
                attrPropery: _requestData.attrPropery || 'data-gss-name',
                attrValue: _requestData.attrValue,
            };
            if (window.History.enabled) {
                if (GSS.common.isNotNullOrEmpty(requestData.url)) {
                    _pageName = _requestData.url;
                }
                else {
                    _pageName = ((new Date).getTime());
                }
                var _preName = void 0;
                var _isChanged = true;
                // get current state
                var _state = window.History.getState();
                if (GSS.common.isNotNullOrEmpty(_state) && GSS.common.isNotNullOrEmpty(_state.data.data)) {
                    _isChanged = service.isChanged(_state.data.data.url, _internal.url);
                }
                _internal.callback = _requestData.callback;
                _internal.callbackData = _requestData.callbackData;
                _internal.isChild = false;
                // if the url is changed compare to previous on, push or replace history
                if (_isChanged) {
                    if (!_replace) {
                        window.History.pushState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.rewriteUrl(customUrl, _pageName.gssHashCode()));
                    }
                    else {
                        window.History.replaceState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.rewriteUrl(customUrl, _pageName.gssHashCode()));
                    }
                }
                // if the url is the same as previous one, replace history
                else {
                    var _newName = service.getPageNameFromUrl('p', window.History.getLocationHref()) + 1;
                    window.History.replaceState({ title: gssHistory.callBackType.request, data: _internal || {} }, document.title, service.getNewUrl(_newName));
                }
            }
            return false;
        }
        gssHistory.manageWithRewriteUrl = manageWithRewriteUrl;
        /**
        * @description Get History' state and re-render the page with its state. Current version only supports a Parent-Child relationship.
        * @param {any} state a qualified history' state from window.History.getState() function.
        */
        function load() {
            return __awaiter(this, arguments, void 0, function (state) {
                var _state, _stateData, _req_1, _isChildCallback_1, _childCallback_1, _callback, _isCallBackAvailable, _preState, _data, _ajaxCallback, _renderContentCallback_1, _domCallback_1, _routeRequest;
                var _this = this;
                if (state === void 0) { state = null; }
                return __generator(this, function (_a) {
                    if (window.History.enabled) {
                        if (state === null) {
                            _state = window.History.getState();
                        }
                        else {
                            _state = state;
                        }
                        _stateData = _state.data;
                        switch (_stateData.title) {
                            case gssHistory.callBackType.request:
                                _req_1 = {
                                    id: _stateData.data.id,
                                    url: _stateData.data.url,
                                    data: _stateData.data.data,
                                    callback: _stateData.data.callback || $.noop(),
                                    callbackData: _stateData.data.callbackData || {},
                                    attrPropery: _stateData.data.attrProperty,
                                    attrValue: _stateData.data.attrValue,
                                    requestDoneCallback: _stateData.data.requestDoneCallback || $.noop(),
                                    requestDoneData: _stateData.data.requestDoneData || {},
                                    ajaxRequestFunction: _stateData.data.ajaxRequestFunction || $.noop(),
                                    renderContentFunction: _stateData.data.renderContentFunction || $.noop(),
                                    domFunction: _stateData.data.domFunction || $.noop(),
                                    portal: _stateData.data.portal,
                                    isChild: _stateData.data.isChild,
                                    childCallback: _stateData.data.childCallback,
                                    childCallbackData: _stateData.data.childCallbackData,
                                };
                                _isChildCallback_1 = true;
                                _childCallback_1 = (function () {
                                    $(document).on('ajaxStop', function () {
                                        var _this = this;
                                        GSS.PortalContainer.progressHide();
                                        if (_isChildCallback_1) {
                                            _isChildCallback_1 = false;
                                            GSS.common.wait(10).done(function () {
                                                if (_req_1.isChild === true) {
                                                    var _childCallback_2 = GSS.common.getFunction(_req_1.childCallback);
                                                    var _childCallbackData = _req_1.childCallbackData || {};
                                                    if (typeof _childCallback_2 === 'function') {
                                                        _childCallback_2.call(_this, _childCallbackData);
                                                        return false;
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }());
                                _callback = void 0;
                                _isCallBackAvailable = false;
                                service.absoluteProgressHide();
                                _preState = window.History.getStateByIndex(window.History.getCurrentIndex() - 1);
                                // check to see if function callBack is set
                                if (GSS.common.isNotNullOrEmpty(_preState.data.data.callback) && (GSS.common.isNotNullOrEmpty(_req_1.callback))) {
                                    // set call back flag
                                    _isCallBackAvailable = (typeof GSS.common.getFunction(_preState.data.data.callback) === 'function');
                                    _callback = GSS.common.getFunction(_req_1.callback);
                                }
                                // callback flag is on, fire callback function
                                if (_isCallBackAvailable) {
                                    // verify the callback function is valid
                                    if (typeof _callback === 'function') {
                                        GSS.PortalContainer.progressLoading();
                                        // fire callback function
                                        _callback.call(this, _req_1.callbackData);
                                        // fire child callback if available
                                        _childCallback_1;
                                    }
                                }
                                // callback flag is off, use internal ajax get request instead
                                else {
                                    _data = {};
                                    GSS.PortalContainer.progressShow();
                                    if (_req_1.portal) {
                                        _data = GSS.pc.Request.setRequiredData(_req_1.id, _req_1.data);
                                    }
                                    else {
                                        _data = PortalContainer.setRequiredData(_req_1.id, _req_1.data);
                                    }
                                    _ajaxCallback = GSS.common.getFunction(_req_1.ajaxRequestFunction);
                                    _renderContentCallback_1 = GSS.common.getFunction(_req_1.renderContentFunction);
                                    _domCallback_1 = GSS.common.getFunction(_req_1.domFunction);
                                    if (_ajaxCallback === undefined || typeof _ajaxCallback !== 'function') {
                                        return [2 /*return*/, false];
                                    }
                                    _routeRequest = _ajaxCallback.call(this, _req_1.url, _data);
                                    _routeRequest.then(function (data) {
                                        if (_renderContentCallback_1 !== undefined) {
                                            if (typeof _renderContentCallback_1 === 'function') {
                                                _renderContentCallback_1.call(this, data, _req_1.attrValue, _req_1.attrPropery);
                                            }
                                        }
                                        // check if there is callback function to fire after request is done
                                        if (GSS.common.isNotNullOrEmpty(_req_1.requestDoneCallback)) {
                                            var _fn = GSS.common.getFunction(_req_1.requestDoneCallback);
                                            if (typeof _fn === 'function') {
                                                // fire callback function
                                                _fn.call(this, _req_1.requestDoneData);
                                            }
                                        }
                                        // fire child callback if available
                                        _childCallback_1;
                                    });
                                    _routeRequest.always(function () {
                                        if (_domCallback_1 !== undefined) {
                                            if (typeof _domCallback_1 === 'function') {
                                                _domCallback_1.call(_this);
                                            }
                                        }
                                        GSS.PortalContainer.progressHide();
                                    });
                                }
                                break;
                            default:
                                window.history.back();
                                break;
                        }
                    }
                    return [2 /*return*/];
                });
            });
        }
        gssHistory.load = load;
        /**
        * @description Utility helper functions that are used in gssHistory.
        */
        var service;
        (function (service) {
            /**
            * @description A helper function to render contents after it comes back from the server.
            * @param {string} data a data come back from server
            * @param {string} attrValue attribute value of a dom to append server's data.
            * @param {string} attrProperty attribute property of a dom to append server's data.
            */
            function renderContent(data, attrValue, attrProperty) {
                if (attrProperty === void 0) { attrProperty = 'data-gss-name'; }
                var _element = attrProperty.gssGetAtt(attrValue);
                if ($(_element).gssElementExists()) {
                    $(_element).empty().html(data);
                }
                else {
                    if ($(attrValue.gssGetId()).length > 0) {
                        $(attrValue.gssGetId()).empty().html(data);
                    }
                    else {
                        void 0;
                    }
                }
            }
            service.renderContent = renderContent;
            /**
            * @description A simple jQuery ajax [GET].
            * @param {string} url a path to action method of a controller.
            * @param {object} data a json object.
            */
            function get(url, data) {
                return $.ajax({
                    type: 'GET',
                    url: url,
                    data: data,
                    cache: false
                });
            }
            service.get = get;
            /**
            * @description This function will retrieve query string value from current browser's url.
            * @param {string} name query string key
            */
            function getParameterByName(name) {
                var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
                return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
            }
            service.getParameterByName = getParameterByName;
            /**
            * @description Get query string value from url
            * @param {string} name query string key
            * @param {string} url a full url
            */
            function getPageNameFromUrl(name, url) {
                var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
                return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
            }
            service.getPageNameFromUrl = getPageNameFromUrl;
            /**
            * @description This function will either add new query string if not already existed or update its value accordingly to existing url
            * @param {string} url a full url
            * @param {string} param a query string key
            * @param {string} value a query string value
            */
            function queryStringUrlReplacement(url, param, value) {
                var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;
                if (match === null) {
                    // append new param
                    var hasQuestionMark = /\?/.test(url);
                    delimiter = hasQuestionMark ? "&" : "?";
                    newString = url + delimiter + param + "=" + value;
                }
                else {
                    delimiter = match[0].charAt(0);
                    newString = url.replace(re, delimiter + param + "=" + value);
                }
                return newString;
            }
            service.queryStringUrlReplacement = queryStringUrlReplacement;
            function rewriteUrl(customUrl, pageId) {
                var _pageId;
                if (typeof (pageId) === 'string') {
                    _pageId = pageId;
                }
                else if (typeof (pageId) === 'number') {
                    _pageId = pageId.toString();
                }
                var _newFullUrl = service.queryStringUrlReplacement(customUrl, 'p', _pageId);
                return _newFullUrl.replace(window.History.getBasePageUrl(), '');
            }
            service.rewriteUrl = rewriteUrl;
            /**
           * @description Replace current browser's url to new url with pageId.
           * @param {string or number} pageId could be string or number type.
           */
            function getNewUrl(pageId) {
                var _pageId;
                if (typeof (pageId) === 'string') {
                    _pageId = pageId;
                }
                else if (typeof (pageId) === 'number') {
                    _pageId = pageId.toString();
                }
                var _newFullUrl = service.queryStringUrlReplacement(window.History.getLocationHref(), 'p', _pageId);
                return _newFullUrl.replace(window.History.getBasePageUrl(), '');
            }
            service.getNewUrl = getNewUrl;
            /**
           * @description Parse url into array.
           * @param {string} url full url string
           */
            function getArray(url) {
                var _arr = url.split('?');
                var _collection = [];
                var _domain = _arr[0].split('/');
                var _controller = _domain[_domain.length - 2];
                var _actionMethod = _domain[_domain.length - 1];
                _collection.push(_controller.gssHashCode());
                _collection.push(_actionMethod.gssHashCode());
                if (_arr.length > 1) {
                    var _tmp = _arr[1].split('&');
                    // get query string values
                    if (GSS.common.isNotNullOrEmpty(_tmp) || _tmp.length > 0) {
                        _tmp.forEach(function (cv, ci) {
                            _collection.push(cv.gssHashCode());
                        });
                    }
                }
                return _collection.sort();
            }
            service.getArray = getArray;
            /**
           * @description Comparing two urls to see if there is a changed.
           * @param {string} url1
           * @param {string} url2
           */
            function isChanged(url1, url2) {
                var _arr1 = service.getArray(url1);
                var _arr2 = service.getArray(url2);
                var _changed = true;
                if (_arr1.length === _arr2.length) {
                    $.each(_arr1, function (i, v) {
                        if ($.inArray(v, _arr2) == -1) {
                            _changed = true;
                            // return false to exit each loop
                            return false;
                        }
                        else {
                            _changed = false;
                        }
                    });
                }
                else {
                    return true;
                }
                return _changed;
            }
            service.isChanged = isChanged;
            /**
            * @description Extract all dom's attributes.
            * @param {string} prop anchor attribute property.
            * @param {string} value anchor attribute value.
            */
            function getAttr(prop, value) {
                if (prop === void 0) { prop = 'class'; }
                if (value === void 0) { value = '.active'; }
                var _collection = [];
                $(value).each(function () {
                    var _attr = '';
                    $.each(this.attributes, function () {
                        if (this.specified) {
                            if (this.name !== prop && this.value !== value) {
                                _attr = _attr + this.name.gssGetAtt(this.value);
                            }
                        }
                    });
                    _collection.push(_attr);
                });
                if (_collection.length > 0) {
                    return _collection.join('|');
                }
                else {
                    return null;
                }
            }
            service.getAttr = getAttr;
            /**
            * @description Force to close progressing message pop up.
            */
            function absoluteProgressHide() {
                $(document).on('ajaxStop', function () {
                    setTimeout(function () {
                        if ($('[data-dyn-el]').length > 0) {
                            $('[data-dyn-el]').each(function () { this.parentNode.removeChild(this); });
                        }
                    }, 300);
                });
            }
            service.absoluteProgressHide = absoluteProgressHide;
        })(service = gssHistory.service || (gssHistory.service = {}));
        /**
        * @description A Jason object that holds callback type when reload the page.
        */
        gssHistory.callBackType = {
            function: 'function',
            request: 'request',
            redirect: 'redirect'
        };
    })(gssHistory = GSS.gssHistory || (GSS.gssHistory = {}));
})(GSS || (GSS = {}));
var _stateChange = true;
var PortalContainer = GSS.PortalContainer;
var pc = GSS.pc;
$(document).on('click', GSS.data.constructDataAtt("data-gss-menu-action", 'data-gss-changeclient-action'), function () { GSS.pc.changeClient(this); return (false); });
$(document).on('click', '#viewComponents', GSS.PortalContainer.redirectToApp);
$(document).on('click', 'data-gss-name'.gssGetAtt('buttonViewAllSupportTile'), GSS.PortalContainer.redirectToApp);
$(document).on('click', 'data-gss-name'.gssGetAtt('buttonViewAllClientsTile'), GSS.PortalContainer.redirectToApp);
$(document).on('click', 'data-gss-name'.gssGetAtt('buttonViewQuestionBankTile'), GSS.PortalContainer.redirectToApp);
$(document).on('click', 'data-gss-name'.gssGetAtt('buttonViewManageCacheTile'), GSS.PortalContainer.redirectToApp);
$(document).on('click', '#bellNotificationClick', GSS.pc.BellNotification.bellNotificationClick);
$(document).on('click', "#skiptocontent", function (e) { e.preventDefault(); e.stopPropagation(); $('#maincontent').trigger('focus'); window.scrollTo(0, 0); });
//# sourceMappingURL=GSS.portalContainer.js.map